<script>
import Vue from 'vue';

var myMixin = {
  computed: {
    error: function () {
      if (this.errors == undefined)
        return '';

      var error = this.errors.filter(function (err) {
        return err.id == this.id;
      }, this)[0];
      if (error) {
        return error.msg;
      } else {
        return '';
      }
    }
  }
}

Vue.component('ajaxLoaderButton', {
  props: ['label','iconclass','onClick','value'],
  data: function() {
    return {
      className: 'btn btn-primary',
      guid: ''
    };
  },
  template: '<button :id="id" :disabled=value :class="className" type="button" v-on:click="click"><i :class="iconclass"></i>{{ label }}</button>',
  mounted: function() {
  },
  watch: {
    value: function(newval, oldval) {
      if (newval) {
        this.className = 'btn btn-primary with-preloader';
        $.fn.spin.presets.preloader = {lines:13, length:0, width:3, radius:10, scale:.75, corners:1, opacity:.25, speed:1};
        $('#'+this.guid).spin('preloader');
      } else if (!newval) {
        this.className = 'btn btn-primary';
        $('#'+this.guid).spin(false);
      }
    }
  },
  computed: {
    id: function() {
      this.guid = this.generateGUID();
      return this.guid;
    }
  },
  methods: {
    generateGUID: function() {
        function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
    click: function() {
      this.onClick();
    }
  }
});

/**
 * Minták:
 * :errors="errors" :datepicker="true" :datepickeropts="{'minDate':'2019-02-16'}" regexp_filter="[0-9]+" mask="99-9999"
 */
Vue.component('inputbox', {
  mixins: [myMixin],
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    errors: {
      type: Array,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    datepicker: {
      type: Boolean,
      required: false,
      default: false
    },
    datepickeropts: {
      type: Object,
      required: false
    },
    maxlength: {
      type: String,
      required: false
    },
    regexp_filter: {
      type: String,
      required: false,
      default: ''
    },
    mask: {
      type: String,
      required: false,
      default: ''
    },
    mask_repeat: {
      type: [String, Number],
      required: false,
      default: 1
    },
    iconclass: {
      type: String,
      required: false,
      default: ''
    },
    iconText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipDescription: {
      type: String,
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'on'
    }
  },
  data: function() {
    return {
      v: ''
    };
  },
  template: `<div class="form-group" v-bind:class="{error: error.length}">
      <label v-if="label != ''" class="form-label"><div style="display:inline-block" v-html="label"></div>
        <Tooltip v-if="tooltipDescription != undefined && tooltipDescription != ''" :description="tooltipDescription"/>
      </label>
      <div class="form-control-container">
        <input :id="id" :class="{withicon:iconclass != ''}" class="form-control" :name="name"
                         :disabled="disabled"
                         :autocomplete="autocomplete"
                         ref="input"
                         type="text"
                         :maxlength="maxlength"
                         :readonly="readonly"
                         :placeholder="placeholder"
                         v-model="v"
                         v-on:keyup="onKeyup"
                         v-on:keydown="onKeydown"
                         v-on:keydown.enter.prevent="onKeydownEnter">
        <div v-if="iconclass != ''" class="form-control-icon">
          <i :class="iconclass"></i>
        </div>
        <div v-if="iconText != ''" class="form-control-icon">
          {{ iconText }}
        </div>
      </div>

		<div v-if="error.length" class="form-error">{{ error }}</div>
	</div>`,
  watch: {
    value: function() {
      this.v = this.value;
    }
  },
  mounted: function() {
    this.v = this.value;

    var _this = this;

    if (this.datepicker != '') {
      var opts = {
        dateFormat: "yy-mm-dd",
        onClose: function(date) {
          _this.updateValue(date);
        }
      };

      if (this.datepickeropts != undefined)
        opts = Object.assign(opts, this.datepickeropts);

      $('#'+this.id).datepicker(opts);
    }
    if (this.regexp_filter != undefined && this.regexp_filter != '') {
      Vue.nextTick(function() {
        var opt = {regex: _this.regexp_filter, oncleared: function() { _this.updateValue($(this).val()); }, onincomplete: function() { _this.updateValue($(this).val()); }, oncomplete: function() { _this.updateValue($(this).val()); }};
        if (_this.mask != undefined && _this.mask != '') {
          opt.mask = _this.mask;
          opt.repeat = _this.mask_repeat;
        }

        $('#' + _this.id).inputmask('Regex', opt);
      });
    }
  },
	methods: {
    onKeydownEnter: function() {
      this.$emit('onkeydownEnter', this.v);
    },
    updateValue: function (value) {
      this.v = value;
      this.$emit('input', value);
      this.$emit('onchange', value);
    },
    onKeyup: function() {
      this.$emit('input', this.v);
      this.$emit('onkeyup', this.v);
    },
    onKeydown: function() {
      this.$emit('onkeydown', this.v);
    },
    updateDatepicker: function(user_opts) {
      var _this = this;
      var opts = {
        dateFormat: "yy-mm-dd",
        onClose: function(date) {
          _this.updateValue(date);
        }
      };

      if (user_opts != undefined)
        opts = Object.assign(opts, user_opts);

      $('#'+this.id).datepicker('destroy');
      $('#'+this.id).datepicker(opts).datepicker("refresh");
    }
  }
});

Vue.component('textareabox', {
  mixins: [myMixin],
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    cstyle: {
      type: String,
      required: false,
      default: ''
    }  ,
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    iconclass: {
      type: String,
      required: false,
      default: ''
    },
    autogrow: {
      type: Boolean,
      required: false,
      default: false
    },
    maxlength: {
      type: String,
      required: false,
      default: '1000'
    },
    tooltipDescription: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function() {
    return {
      chars: 0
    };
  },
  template: `<div class="form-group" v-bind:class="{error: error.length}">
		<label v-if="label != ''" class="form-label">{{ label }}
      <Tooltip v-if="tooltipDescription != undefined && tooltipDescription != ''" :description="tooltipDescription"/>
    </label>
        <div class="form-control-container" :class="{maxlengthinfo: maxlength != ''}">
            <textarea style="height: 200px" :id="id" :class="{withicon:iconclass != ''}" class="form-control autogrow" v-bind:name="name"
                             v-bind:style="cstyle"
                             v-bind:disabled="disabled"
														 ref="input"
                             v-bind:maxlength="maxlength"
													 	 v-bind:value="value"
                             :placeholder="placeholder"
														 v-on:input="updateValue($event.target.value)">
                             </textarea>
          <div v-if="maxlength != ''" class="form-control-char-count">{{ chars }}</div>
          <div v-if="iconclass != ''" class="form-control-icon">
            <i :class="iconclass"></i>
          </div>
        </div>
		<div v-if="error.length" class="form-error">{{ error }}</div>
	</div>`,
  watch: {
    value: function() {
      if (this.maxlength != '')
        this.setChars();
    }
  },
  mounted: function() {
    var _this = this;

    Vue.nextTick(function() {
      if (_this.autogrow !== false) {
        $('#' + _this.id).autogrow();
      }

      if (_this.maxlength != '') {
        _this.setChars();
      }
    });
  },
	methods: {
    setChars: function() {
      this.chars = 'Még ' + (this.maxlength - this.value.length) + ' karakter írható. ' + this.value.length + ' beírt karakter.';
    },
    updateValue: function (value) {
      this.$emit('input', value);

      if (this.maxlength != '')
        this.setChars();
    }
  }
});

Vue.component('passwordbox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','keyup','keydownEnter'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <input :id="id" class="form-control" v-bind:name="name"\
														 ref="input"\
													 	 type="password"\
													 	 v-bind:value="value"\
                             v-on:keyup="onKeyup"\
                             v-on:keydown.enter.prevent="onKeydownEnter"\
														 v-on:input="updateValue($event.target.value)">\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
	methods: {
    onKeydownEnter: function() {
      if (this.keydownEnter != undefined)
        this.keydownEnter();
    },
    updateValue: function (value) {
      this.$emit('input', value);
    },
    onKeyup: function() {
      if (this.keyup != undefined)
        this.keyup(this.value);
    }
  }
});

Vue.component('checkbox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
    <div class="checkbox"><input :id="id" v-bind:name="name"\
														 v-model="value.selected"\
													 	 type="checkbox"\
													 	 v-bind:value="value.value"><label :for="id">{{ label }}</label></div>\
	 	<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>'
});

Vue.component('radio', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
    <div class="radio"><input :id="id" v-bind:name="name"\
														 v-model="value.selected"\
													 	 type="radio"\
													 	 v-bind:value="value.value"><label :for="id">{{ label }}</label></div>\
	 	<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>'
});

Vue.component('toggle', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <div><input :id="id" style="display:none" v-bind:name="name"\
														 v-model="value.selected"\
													 	 type="checkbox"\
													 	 v-bind:value="value.value">\
<div class="toggle-wrapper"><div v-on:click="toggle" class="toggle" v-bind:class="{active}"><div class="toggle-slide"><div class="toggle-inner"><div class="toggle-on">Igen</div><div class="toggle-blob"></div><div class="toggle-off">Nem</div></div></div></div></div>\
</div>\
	 	<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  computed: {
    active: function() {
      return this.value.selected ? "active" : "";
    }
  },
  methods: {
    toggle: function() {
      this.value.selected = !this.value.selected;
    }
  }
});

Vue.component('checkboxes', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
		<div v-for="(v, index) in value.items">\
		  <div class="checkbox"><input :id="inputid(index)" v-bind:value="v.value"\
										v-bind:name="name"\
										v-model="value.selected"\
										type="checkbox"><label :for="inputid(index)">{{ v.label }}</label>\
      </div>\
		</div>\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  methods: {
    inputid: function(index) {
      return this.name + "_" + index;
    }
  }
});

Vue.component('radios', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
		<div v-for="(v, index) in value.items">\
			<div class="radio"><input :id="inputid(index)" v-bind:index="index"\
										v-bind:value="v.value"\
										v-bind:name="name"\
										v-model="value.selected"\
										type="radio"><label :for="inputid(index)">{{ v.label }}</label>\
      </div>\
		</div>\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  methods: {
    inputid: function(index) {
      return this.name + "_" + index;
    }
  }
});

Vue.component('combobox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','change','disabled','cvalue','index'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select v-bind:disabled="disabled" v-on:change="onChange(value.selected)" class="form-control" v-bind:name="name" v-bind:id="id" v-model="value.selected">\
				<option v-for="item in value.items" v-bind:value="item.value">{{item.label}}</option>\
			</select>\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  methods: {
    onChange: function(val) {
      if (this.change != undefined)
        this.change(val,this.index);
    }
  },
  computed: {
    selected_value: function() {
      return this.cvalue ? this.cvalue : this.value.selected;
    }
  }
});

Vue.component('comboboxV2', {
  mixins: [myMixin],
  data: function() {
    return {
      v: 0
    }
  },
  props: ['label','value','errors','id','name','disabled','options','tooltipDescription'],
  template: `<div class="form-group" v-bind:class="{error: error.length}">
		<label v-if="label != ''" class="form-label"><div style="display:inline-block" v-html="label"></div><Tooltip v-if="tooltipDescription != undefined && tooltipDescription != ''" :description="tooltipDescription"/></label>
			<select :disabled="disabled" class="form-control" v-on:change="onChange" :name="name" :id="id" v-model="v">
				<option v-for="o in options" :value="o.value">{{o.label}}</option>
			</select>
		<div v-if="error.length" class="form-error">{{ error }}</div>
	</div>`,
  watch: {
    value: function() {
      this.v = this.value;
    },
  },
  mounted: function() {
    this.v = this.value;
  },
  methods: {
    onChange: function() {
      this.$emit('input', this.v);
      this.$emit('onChange', this.v);
    },
  }
});

Vue.component('radiosV2', {
  mixins: [myMixin],
  data: function() {
    return {
      v: 0
    }
  },
  props: ['label','value','errors','id','name','disabled','items','tooltipDescription'],
  template: `<div class="form-group" v-bind:class="{error: error.length}">
		<label v-if="label != ''" class="form-label"><div style="display:inline-block" v-html="label"></div><Tooltip v-if="tooltipDescription != undefined && tooltipDescription != ''" :description="tooltipDescription"/></label>
    <div class="radio" v-for="(item, i) in items">
      <input :disabled="disabled" type="radio" v-on:change="onChange" :name="name" :id="id+'_'+i" :value="item.value" v-model="v"/>
      <label :for="id+'_'+i">{{ item.label }}</label>
    </div>
		<div v-if="error.length" class="form-error">{{ error }}</div>
	</div>`,
  watch: {
    value: function() {
      this.v = this.value;
    },
  },
  mounted: function() {
    this.v = this.value;
  },
  methods: {
    onChange: function() {
      this.$emit('input', this.v);
      this.$emit('onChange', this.v);
    },
  }
});

Vue.component('select2', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','multi','change','disabled'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select v-bind:disabled="disabled" :multiple="multiple" class="form-control select2js" v-bind:name="name" v-bind:id="id" v-model="value.selected">\
				<option v-for="item in value.items" v-bind:value="item.value">{{item.label}}</option>\
			</select>\
    <div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  mounted: function() {
    var _this = this;
    $('#'+this.id).select2({placeholder: 'Válasszon...'})
    .on("select2:select", function (e) {
      _this.value.selected = $('#'+_this.id).val();
      if (_this.change != undefined)
        _this.change(_this.value.selected);
    })
    .on("select2:unselect", function (e) {
      _this.value.selected = $('#'+_this.id).val();
      if (_this.change != undefined)
        _this.change(_this.value.selected);
    });
  },
  computed: {
    multiple: function() {
      return this.multi == "true" ? true : false;
    }
  }
});

Vue.component('select2ajax', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','multi','change','disabled','url'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select v-bind:disabled="disabled" :multiple="multiple" class="form-control select2js" v-bind:name="name" v-bind:id="id" v-model="value.selected">\
				<option v-for="item in value.items" v-bind:value="item.value">{{item.label}}</option>\
			</select>\
    <div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  mounted: function() {
    var _this = this;
    $('#'+this.id).select2({
      placeholder: 'Kezdjen el írni...',
      language: 'hu',
      ajax: {
        url: 'api/'+this.url,
        dataType: 'json',
        delay: 250,
        method: 'POST',
        data: function (params) {
          return {
            q: params.term,
            page: params.page
          };
        },
        processResults: function (data, params) {
          return {
            results: data.items
          };
        },
        cache: true
      },
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2
    }).on("select2:select", function (e) {
      _this.value.selected = $('#'+_this.id).val();
      if (_this.change != undefined)
        _this.change(_this.value.selected);
    })
    .on("select2:unselect", function (e) {
      _this.value.selected = $('#'+_this.id).val();
      if (_this.change != undefined)
        _this.change(_this.value.selected);
    });
  },
  computed: {
    multiple: function() {
      return this.multi == "true" ? true : false;
    }
  }
});

Vue.component('pagination', {
  props: ['limit','amount','value','showcombo'],
  data: function() {
     return {
         page: parseInt(this.value),
         from: 1,
         to: 0,
         pagec: 0
     };
  },
  template: '<section>\n\
<div style="padding-bottom: 10px;">Összesen {{ amount }} találat, {{ pagec }} lapon.</div>\n\
<ul class="pagination">\n\
  <li v-if="showcombo"><select v-model="page" v-on:change="comboChange" class="form-control"><option v-for="i in comboIndex" v-bind:value="i">{{i}}</option></select></li>\n\
  <li><a v-on:click="firstClick" href="javascript:void(0)" aria-label="Első"><span aria-hidden="true"><i class="fa fa-angle-double-left"></i></span></a></li>\n\
  <li><a v-on:click="prevClick()" href="javascript:void(0)" aria-label="Előző"><span aria-hidden="true"><i class="fa fa-angle-left"></i></span></a></li>\n\
  <li v-for="i in renderLiIndex" v-bind:class="{active: i == page}"><a v-on:click="pageClick(i)" href="javascript:void(0)">{{ i }}</a></li>\n\
  <li><a v-on:click="nextClick" href="javascript:void(0)" aria-label="Következő"><span aria-hidden="true"><i class="fa fa-angle-right"></i></span></a></li>\n\
<li><a v-on:click="lastClick" href="javascript:void(0)" aria-label="Utolsó"><span aria-hidden="true"><i class="fa fa-angle-double-right"></i></span></a></li>\n\
</ul>\n\
</section>',
  mounted: function() {
    this.calcToFrom();
  },
  computed: {
    renderLiIndex: function() {
      var arr = [];
      for (var i = this.from; i <= this.to; i++) {
        arr.push(i);
      }
      return arr;
    },
    comboIndex: function() {
      var arr = [];
      for (var i = 1; i <= this.pagec; i++) {
        arr.push(i);
      }
      return arr;
    }
  },
  watch: {
    value: function(newval, oldval) {
      this.page = parseInt(newval);
      this.calcToFrom();
    },
    page: function(newval, oldval) {
      this.page = parseInt(newval);
      this.calcToFrom();
    },
    amount: function(newval, oldval) {
      this.calcToFrom();
    },
    limit: function(newval, oldval) {
      this.calcToFrom();
    },
  },
  methods: {
    calcToFrom: function() {
      var page = parseInt(this.page);
      var amount = parseInt(this.amount);
      var limit =  parseInt(this.limit);
      var from = parseInt(this.from);
      var to = parseInt(this.to);

      this.pagec = Math.ceil(amount / limit);

      if (this.pagec >= 7) {
        if (page - 3 <= 1) {
          this.from = 1;
          this.to = from + 6;

        } else if (page + 3 <= this.pagec) {
          this.from = page - 3;
          this.to = page + 3;
        } else {
          var extra = (page + 3) - this.pagec;
          this.from = (page - 3) - extra;
          this.to = this.pagec;
        }
      } else {
        this.from = 1;
        this.to = this.pagec;
      }
    },
    comboChange: function() {
      this.$emit('pageChanged', this.page);
    },
    pageClick: function(page) {
      this.page = page;
      this.$emit('pageChanged', page);
    },
    prevClick: function() {
      if (this.page > 1)
        this.page = this.page - 1;

      this.$emit('pageChanged', this.page);
    },
    nextClick: function() {
      if ((parseInt(this.page) + 1) > this.pagec) {
        this.page = this.pagec;
      } else {
        this.page = parseInt(this.page) + 1;
      }
      this.$emit('pageChanged', this.page);
    },
    lastClick: function() {
      this.page = this.pagec;
      this.$emit('pageChanged', this.page);
    },
    firstClick: function() {
      this.page = 1;
      this.$emit('pageChanged', this.page);
    }
  },
});

Vue.component('evaulationDrag', {
  props: ["label"],
  data: function() {
    return {
      w: 0,
      mx: 0,
      x: 0,
      sx: 0,
      dx: 0,
      max_point: 5,
      point: 0,
      dragger: '.evaluation .dragger'
    };
  },
  template: `
  <div class="evaluation">
    <div class="text">
      {{ label }}
    </div>
    <div class="drag-wrapper">
      <div class="bg">
        <div class="dragger" :style="draggerStyle">
        </div>
      </div>
      <div class="value">
        <span>{{ point }}</span> / {{ max_point }}
      </div>
    </div>
  </div>
  `,
  mounted: function() {
    var _this = this;

    this.w = $('.evaluation .bg').width();
    this.dx = this.w / this.max_point;

    $(this.dragger).mousedown(function(e) {
      _this.mx = e.pageX;
      _this.sx = _this.x;
      $(document).bind('mousemove', _this.drag);
      $(document).bind('mouseup', _this.up);
    });
  },
  computed: {
    draggerStyle: function() {
      return {
        'left': this.x + 'px'
      }
    },
  },
  methods: {
    drag: function(e) {
      this.x = this.sx + (e.pageX - this.mx);

      this.x = Math.ceil(this.x / this.dx) * this.dx;

      this.point = this.x / this.dx;

      if (this.point > this.max_point)
        this.point = this.max_point;

      if (this.point <= 0)
        this.point = 0;

      if (this.x < 0)
        this.x = 0;

      if (this.x > this.w - $(this.dragger).width())
        this.x = this.w - $(this.dragger).width();

    },
    up: function() {
      $(document).unbind('mousemove', this.drag);
      $(document).unbind('mouseup', this.up);
      this.$emit('changePoint', parseInt(this.point));
    }
  }
});

Vue.component('ProgressInfo', {
  props: {
    text: {
      type: String,
      required: false
    },
    show: {
      type: Boolean,
      required: true
    },
    hideProgressInfo: {
      type: Function,
      required: true
    }
  },
  data: function() {
    return {
      textd: (this.text == undefined ? 'Kérem várjon...' : this.text)
    };
  },
  template: `
    <div class="save-progess-bar">
      <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>{{ textd }}
    </div>
  `,
  watch: {
    show: function(nv, ov) {
      var _this = this;

      if (nv) {
        $('.save-progess-bar').addClass('show');
        setTimeout(function() {
          $('.save-progess-bar').removeClass('show');
          _this.hideProgressInfo();
        }, 2000);
      }
    }
  }
});

Vue.component('UploadHandler', {
  props: ['label','errors','id','name','accepted_files','loaded_files','max_uploaded_files','default_value','tooltipDescription'],
  mixins: [myMixin],
  data: function() {
    return {
      maxfiles: 1,
      dropzone: '',
      files: [],
      file_upload_in_progress: false,
      max_uploaded_filesize_mb: 0,
      max_uploaded_filesize: 0,
      df: ''
    };
  },
  template: `
    <div class="form-group" v-bind:class="{error: error.length}">
      <label v-if="label != ''" class="form-label"><div style="display:inline-block" v-html="label"></div>
        <Tooltip v-if="df.tooltipDescription != undefined && df.tooltipDescription != ''" :description="df.tooltipDescription"/>
        <Tooltip v-if="tooltipDescription != undefined && tooltipDescription != ''" :description="tooltipDescription"/>
      </label>
      <div v-if="df.msg != undefined" class="info-box warning" style="margin:2px 0px" v-html="df.msg"></div>
      <div v-if="files != undefined && files.length > 0">
        <div v-for="(item, i) in files" class="profile-publication-item">
          <div class="text">
            <i class="fa fa-file-o"></i><a target="_blank" :href="getFilePath(item)">{{ item }}</a>
          </div>
          <div class="links">
            <a v-on:click="deleteUploadedFile(item)" href="javascript:void(0)" class="link v2"><i class="fa fa-trash-o"></i></a>
          </div>
        </div>
      </div>
      <div :class="{disabled:file_upload_in_progress}" v-show="files.length < maxfiles" :id="id" class="upload-zone">
        <svg v-show="file_upload_in_progress" class="preloader" width="32" height="32" viewBox="0 0 66 66">
          <circle stroke="#dbdbdb" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
          <circle class="preloader-path" stroke="#68B4AE" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
        <i class="fa fa-cloud-upload"></i>
        Új dokumentum feltöltés
        <span style="text-align:center">Húzza ide a feltöltendő fájlokat. <strong>{{ maxfiles - files.length }} fájl</strong> tölthető fel.<br>A feltöltendő fájl mérete maximum <strong>{{ max_uploaded_filesize_mb }} mb</strong> lehet.<br>Feltölthető fájltípusok: <strong>{{ filetypes }}</strong></span>
        <input :name="name" type="file" />
      </div>
      <div v-if="error.length" class="form-error">{{ error }}</div>
    </div>
  `,
  computed: {
    filetypes: function() {
      var types = this.accepted_files.split(",");
      var s = [];

      types.map(function(type) {
        if (type == 'image/jpeg')
          s.push('jpg');

        if (type == 'application/pdf' || type == 'application/x-pdf')
          s.push('pdf');

        if (type == 'application/vnd.ms-excel' || type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          s.push('xls (excel)');

        if (type == 'application/msword' || type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
          s.push('doc, docx');

        if (type == 'application/vnd.ms-powerpoint' || type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || type == '.ppt' || type == '.pptx')
          s.push('ppt, pptx');
      });

      s = s.filter((v, i, a) => a.indexOf(v) === i);
      return s.join(", ");
    }
  },
  mounted: function() {
    if (this.max_uploaded_files != undefined)
      this.maxfiles = this.max_uploaded_files;

    if (this.default_value != undefined && this.default_value != '') {
      this.df = JSON.parse(this.default_value);
    }

    this.initializeDropzone();
    this.getMaxUploadedFileSize();
  },
  watch: {
    loaded_files: {
      immediate: true,
      handler: function(val, oldVal) {
        if (this.loaded_files != undefined && this.loaded_files != '')
          this.files = this.loaded_files;
      }
    },
    max_uploaded_files() {
      this.maxfiles = this.max_uploaded_files;
    }
  },
  methods: {
    getMaxUploadedFileSize: function() {
      var _this = this;

      this.$root.ajax('max_feltoltheto_fajlmeret/', {
        success: function(response) {
          _this.max_uploaded_filesize_mb = response.max_uploaded_filesize_mb;
          _this.max_uploaded_filesize = response.max_uploaded_filesize;
        }
      });
    },
    deleteFiles: function() {
      this.files = [];
      this.$emit('change', this.files);
      if (this.dropzone != '') {
        this.dropzone.destroy();
        this.initializeDropzone();
      }
    },
    getFilePath: function(file) {
      return 'api/uploads/' + file;
    },
    deleteUploadedFile: function(file) {
      var _this = this;

      swal({
        title: "Biztos törli a feltöltött dokumentumot?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Nem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          var tmp = [];
          _this.files.map(function(item) {
            if (item != file)
              tmp.push(item);
          });
          _this.files = tmp;

          _this.$emit('change', _this.files);

          _this.dropzone.destroy();
          _this.initializeDropzone();
        }
      });
    },
    initializeDropzone: function() {
      var _this = this;

      Vue.nextTick(function() {
        _this.dropzone = new Dropzone("#" + _this.id, {
          url: api_url + 'form/uploadfile/',
          method: 'post',
          paramName: _this.name,
          autoProcessQueue: true,
          parallelUploads: 1,
          maxFiles: _this.maxfiles - _this.files.length,
          acceptedFiles: _this.accepted_files,
          previewsContainer: false,
          autoDiscover: false,
          init: function () {
            this.on("success", function (file, response) {
              if (!$.isPlainObject(response))
                response = JSON.parse(response);

              if (response.error == false) {
                response.uploaded_files.map(function(file) {
                  _this.files.push(file);
                });
                _this.$emit('change', _this.files);
              } else {
                this.removeFile(file);
                swal('Hiba', response.error, 'error');
              }
            });
            this.on("sending", function (response) {
              _this.file_upload_in_progress = true;
            }),
            this.on("queuecomplete", function (response) {
              this.removeAllFiles(true);
              _this.file_upload_in_progress = false;
              _this.dropzone.destroy();
              _this.initializeDropzone();
            });
            this.on("addedfile", function (file) {
              if (file.size > _this.max_uploaded_filesize) {
                this.removeFile(file);
                swal('Hiba', 'Túl nagy a feltöltendő fájl mérete ('+file.name+'). Maximum ' + _this.max_uploaded_filesize_mb + ' Mb tölthető fel.', 'error');
                return;
              }

              if ((file.type != '' && $.inArray(file.type, _this.accepted_files.split(',')) == -1) || (file.type == '' && $.inArray('.'+file.name.split('.').pop(), _this.accepted_files.split(',')) == -1)) {
                this.removeFile(file);
                swal('Hiba', 'A feltöltendő fájltípus nem engedélyezett.', 'error');
              } else if (_this.files.length + 1 > _this.maxfiles) {
                this.removeFile(file);
                swal('Hiba', 'Maximálisan ' + _this.maxfiles + ' fájl tölthető fel.', 'error');
              }
            });
          }
        });
      });
    }
  }
});

Vue.component('UploadHandlerWithCombo', {
  props: {
    label: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    accepted_files: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    max_uploaded_files: {
      type: [String, Number],
      required: true
    },
    block_point: {
      type: Number,
      required: false,
      default: 0
    }
  },
  mixins: [myMixin],
  data: function() {
    return {
      maxfiles: this.max_uploaded_files == undefined ? 3 : this.max_uploaded_files,
      dropzone: '',
      comboValue: 0,
      uploadedFiles: [],
      file_upload_in_progress: false,
      max_uploaded_filesize_mb: 0,
      max_uploaded_filesize: 0
    };
  },
  template: `
    <div class="form-group" v-bind:class="{error: error.length}">
      <label class="form-label">{{ label }} <span v-if="block_point != undefined" style="font-weight:400">({{block_point}} pont)</span></label>
      <div style="margin-bottom: 10px" v-if="uploadedFiles.length > 0">
        <div v-for="(item, i) in uploadedFiles" class="profile-publication-item">
          <div class="text">
            <i class="fa fa-file-o"></i><a target="_blank" :href="getFilePath(item.file)">{{ item.file }}</a> ({{ item.comboLabel }})
          </div>
          <div class="links">
            <a v-on:click="deleteUploadedFile(item.file)" href="javascript:void(0)" class="link v2"><i class="fa fa-trash-o"></i></a>
          </div>
        </div>
      </div>
      <select :disabled="file_upload_in_progress" v-if="this.uploadedFiles.length != maxfiles" v-on:change="comboChange" style="margin-bottom: 10px" class="form-control" :name="'combo_'+name" :id="'combo_'+name" v-model="comboValue">
        <option v-if="option.show == 1" v-for="(option, i) in options" :value="option.value">{{ option.text }}</option>
      </select>
      <div :class="{disabled:file_upload_in_progress}" v-show="uploadedFiles.length < maxfiles && comboValue != 0" :id="id" class="upload-zone">
        <svg v-show="file_upload_in_progress" class="preloader" width="32" height="32" viewBox="0 0 66 66">
          <circle stroke="#dbdbdb" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
          <circle class="preloader-path" stroke="#68B4AE" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
        <i class="fa fa-cloud-upload"></i>
        Új dokumentum feltöltés
        <span>Húzza ide a feltöltendő fájlokat. {{ maxfiles - uploadedFiles.length }} fájl tölthető fel.</span>
        <input :name="name" type="file" />
      </div>
      <div v-if="error.length" class="form-error">{{ error }}</div>
    </div>
  `,
  mounted: function() {
    var _this = this;

    this.options.unshift({
      value: 0,
      show: 1,
      text: '- válasszon -'
    });

    this.initializeDropzone();
    this.getMaxUploadedFileSize();
  },
  methods: {
    getMaxUploadedFileSize: function() {
      var _this = this;

      this.$root.ajax('max_feltoltheto_fajlmeret/', {
        success: function(response) {
          _this.max_uploaded_filesize_mb = response.max_uploaded_filesize_mb;
          _this.max_uploaded_filesize = response.max_uploaded_filesize;
        }
      });
    },

    changeComboValue: function(value) {
      this.comboValue = value;
    },

    getComboLabelByValue: function(value) {
      var text = '';
      this.options.map(function(option) {
        if (option.value == value)
          text = option.text;
      });
      return text;
    },

    getFilePath: function(file) {
      return 'assets/uploads/' + file;
    },

    getValue: function() {
      var _this = this;
      var r = [];

      this.options.map(function(option) {
        if (option.value != 0) {
          var files = [];

          _this.uploadedFiles.map(function(uf) {
            if (parseInt(uf.comboValue) == parseInt(option.value))
              files.push(uf.file);
          });

          r.push({
            id: option.value,
            files: files
          })
        }
      });

      return r;

      /*
      this.uploadedFiles.map(function(item) {
        var r_item_ = '';

        r.map(function(r_item) {
          if (r_item.id == parseInt(item.comboValue))
            r_item_ = r_item;
        });
        if (r_item_ != '') {
          r_item_.files.push(item.file);
        } else {
          r.push({
            id: parseInt(item.comboValue),
            files: [item.file]
          });
        }
      });

      return r;*/
    },

    comboChange: function() {
      this.$emit('change', this.getValue());
    },

    deleteUploadedFile: function(file) {
      var _this = this;

      swal({
        title: "Biztos törli a feltöltött dokumentumot?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Nem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          var tmp = [];
          _this.uploadedFiles.map(function(file_) {
            if (file != file_.file)
              tmp.push(file_);
          });
          _this.uploadedFiles = tmp;

          _this.$emit('change', _this.getValue());

          _this.dropzone.destroy();
          _this.initializeDropzone();
        }
      });
    },

    initializeDropzone: function() {
      var _this = this;

      Vue.nextTick(function() {
        _this.dropzone = new Dropzone("#" + _this.id, {
          url: api_url + 'form/uploadfile/',
          method: 'post',
          paramName: _this.name,
          autoProcessQueue: true,
          parallelUploads: 1,
          maxFiles: _this.maxfiles - _this.uploadedFiles.length,
          acceptedFiles: _this.accepted_files,
          previewsContainer: false,
          autoDiscover: false,
          init: function () {
            this.on("success", function (file, response) {
              if (!$.isPlainObject(response))
                response = JSON.parse(response);

              if (response.error == false) {
                response.uploaded_files.map(function(file) {
                  _this.uploadedFiles.push({
                    file: file,
                    comboValue: _this.comboValue,
                    comboLabel: _this.getComboLabelByValue(_this.comboValue)
                  });
                });

                _this.$emit('change', _this.getValue());

              } else {
                this.removeFile(file);
                swal('Hiba', response.error, 'error');
              }
            });
            this.on("sending", function (response) {
              _this.file_upload_in_progress = true;
            }),
            this.on("queuecomplete", function (response) {
              this.removeAllFiles(true);
              _this.file_upload_in_progress = false;
              _this.dropzone.destroy();
              _this.initializeDropzone();
            });
            this.on("addedfile", function (file) {
              if (file.size > _this.max_uploaded_filesize) {
                this.removeFile(file);
                swal('Hiba', 'Túl nagy a feltöltendő fájl mérete. Maximum ' + _this.max_uploaded_filesize_mb + 'Mbyte tölthető fel.', 'error');
                return;
              }

              if ($.inArray(file.type, _this.accepted_files.split(',')) == -1) {
                this.removeFile(file);
                swal('Hiba', 'A feltöltendő fájltípus nem engedélyezett.', 'error');
              } else if (_this.uploadedFiles.length + 1 > _this.maxfiles) {
                this.removeFile(file);
                swal('Hiba', 'Maximálisan ' + _this.maxfiles + ' fájl tölthető fel.', 'error');
              }
            });
          }
        });
      });
    }
  }
});

Vue.component('Form', {
  props: ['form', 'field', 'childs'],
  data: function() {
    return {
      hasFill: false,
      errors: [],
      contact_data: ''
    };
  },
  template: `
    <div>
      <div v-if="hasFill == false">
        <h2 class="form-name">{{ form.name }}</h2>
        <div v-if="contact_data != '' && form.show_contact_data == 1" class="info-box" style="margin-top: 20px;">
          <ul class="ordered-list with-icon">
            <li v-if="contact_data.nev != ''">
              <i class="fa fa-user"></i><span class="highlight">Név:</span> {{ contact_data.nev }}
            </li>
            <li v-if="contact_data.szervezeti_egyseg != ''">
              <i class="fa fa-university"></i><span class="highlight">Szervezeti egység:</span> {{ contact_data.szervezeti_egyseg }}
            </li>
            <li v-if="contact_data.iroda != ''">
              <i class="fa fa-briefcase"></i><span class="highlight">Iroda:</span> {{ contact_data.iroda }}
            </li>
            <li v-if="contact_data.telefon != ''">
              <i class="fa fa-phone"></i><span class="highlight">Telefon:</span> {{ contact_data.telefon }}
            </li>
            <li v-if="contact_data.email != ''">
              <i class="fa fa-envelope"></i><span class="highlight">Email:</span> <a :title="contact_data.email" :href="'mailto:'+contact_data.email">{{ contact_data.email }}</a>
            </li>
          </ul>
        </div>
        <FormSection ref="first_section" :errors="errors" v-on:saveClick="save" v-on:preSaveClick="preSave" :form="form" :field="field" :childs="childs"></FormSection>
      </div>
      <div v-if="hasFill == true">
      <h2 class="form-name">{{ form.name }}</h2>
      {{ form.thanx_msg }}
      </div>
    </div>
  `,

  beforeMount: function() {
    var _this = this;

    if (this.form.contact_data != '' && this.form.contact_data != null)
      this.contact_data = JSON.parse(this.form.contact_data);

    _this.$root.ajax('form/fill_load/' + _this.form.id, {
      success: function(response) {
        if (response.has_fill != undefined) {
          _this.hasFill = true;
          _this.form.thanx_msg = 'Ön már véglegesítette kitöltését.'
        }

        if (response.values != undefined)
          _this.form.values = response.values;
      }
    });
  },


  computed: {
    contactData: function() {
      if (this.form.contact_data != '' && this.form.contact_data != null) {
        return JSON.parse(this.form.contact_data);
      } else {
        return '';
      }
    }
  },

  mounted: function() {
    var _this = this;

    // Automatikusan kitölti a mezőket a bejelentkezett $root.user adataiból
    if (this.$root.user.name != undefined && this.form.values.nev != undefined)
      this.form.values.nev = this.$root.user.name;

    if (this.$root.user.neptuncode != undefined && this.form.values.neptunkod != undefined)
      this.form.values.neptunkod = this.$root.user.neptuncode;

    if (this.$root.user.birthdate != undefined && this.form.values.szulido != undefined)
      this.form.values.szulido = this.$root.user.birthdate;

    if (this.$root.user.birthplace != undefined && this.form.values.szulhely != undefined)
      this.form.values.szulhely = this.$root.user.birthplace;

    if (this.$root.user.email != undefined && this.form.values.email != undefined)
      this.form.values.email = this.$root.user.email;

    if (this.$root.user.taxnumber != undefined && this.form.values.adoazonosito_jel != undefined)
      this.form.values.adoazonosito_jel = this.$root.user.taxnumber;

    if (this.$root.user.phone != undefined && this.form.values.telefonszam != undefined)
      this.form.values.telefonszam = this.$root.user.phone;

    if (this.$root.user.postalcode != undefined && this.$root.user.city != undefined && this.$root.user.address != undefined && this.form.values.allando_lakcim != undefined)
      this.form.values.allando_lakcim = this.$root.user.postalcode+' '+this.$root.user.city+', '+this.$root.user.address;

    if (this.$root.user.anyja_neve != undefined && this.form.values.anyja_neve != undefined)
      this.form.values.anyja_neve = this.$root.user.anyja_neve;

    if (this.$root.user.adoazonosito_jel != undefined && this.form.values.adoazonosito_jel != undefined)
      this.form.values.adoazonosito_jel = this.$root.user.adoazonosito_jel;

    if (this.$root.user.taj_szam != undefined && this.form.values.taj_szam != undefined)
      this.form.values.taj_szam = this.$root.user.taj_szam;
  },

  methods: {
    getFieldByName: function(_this, fields, name, f) {
      var _this = _this;

      fields.map(function(field) {
        if (field.name == name)
          f = field;

        if (field.childs.length > 0 && f == false)
          f = _this.getFieldByName(_this, field.childs, name, f);
      });

      return f;
    },

    save: function() {
      var _this = this;

      this.errors = [];

      // Mező kitöltés vizsgálata
      // Adatbázisban a köv. képpen van tárolva: Akkor hibás a mező, ha...
      for (var field_name in this.form.values) {
        var field = _this.getFieldByName(_this, _this.form.fields, field_name, false);

        if (field.criterions != undefined) {
          field.criterions.map(function(criterion) {
            if (criterion.type == 'Kötelező') {
              var e = '';

              criterion.items.map(function(item) {
                switch(item.criterion_name) {
                  case "Zárójel nyit":
                    e = e + "(";
                  break;
                  case "Zárójel zár":
                    e = e + ")";
                  break;
                  case "Kitöltött":
                    e = e + "(_this.form.values."+item.field_name+" != '' && _this.form.values."+item.field_name+" != 0 && _this.form.values."+item.field_name+" != false)";
                  break;
                  case "Nem kitöltött":
                    e = e + "(_this.form.values."+item.field_name+" == '' || _this.form.values."+item.field_name+" == 0 || _this.form.values."+item.field_name+" == false)";
                  break;
                  case "Egyenlő":
                    e = e + "_this.form.values."+item.field_name+" == " + item.value;
                  break;
                  case "Nem egyenlő":
                    e = e + "_this.form.values."+item.field_name+" != " + item.value;
                  break;
                  case "Kisebb mint":
                    e = e + "_this.form.values."+item.field_name+" < " + item.value;
                  break;
                  case "Nagyobb mint":
                    e = e + "_this.form.values."+item.field_name+" > " + item.value;
                  break;
                  case "Kisebb egyenlő":
                    e = e + "_this.form.values."+item.field_name+" <= " + item.value;
                  break;
                  case "Nagyobb egyenlő":
                    e = e + "_this.form.values."+item.field_name+" >= " + item.value;
                  break;
                  case "Igaz":
                    e = e + "_this.form.values."+item.field_name+" == true";
                  break;
                  case "Hamis":
                    e = e + "_this.form.values."+item.field_name+" == false";
                  break;
                  case "Tartalmaz":
                    e = e + "jQuery.inArray("+item.value+", _this.form.values."+item.field_name+") > 0";
                  break;
                  case "Nem tartalmaz":
                    e = e + "jQuery.inArray("+item.value+", _this.form.values."+item.field_name+") == -1";
                  break;
                  case "Szöveget tartalmaz":
                    e = e + "_this.form.values."+item.field_name+".indexOf('"+item.value+"') > -1";
                  break;
                  case "Szöveget nem tartalmaz":
                    e = e + "_this.form.values."+item.field_name+".indexOf('"+item.value+"') < 0";
                  break;
                  case "És":
                    e = e + " && ";
                  break;
                  case "Vagy":
                    e = e + " || ";
                  break;
                  case "Feltöltőblokkban fájlok feltöltve":
                    if (!Array.isArray(_this.form.values[item.field_name]) && _this.form.values[item.field_name] == '') {
                      e = e + "_this.form.values."+item.field_name+" == ''";
                    } else if (Array.isArray(_this.form.values[item.field_name])) {
                      var block_empty = false;
                      _this.form.values[item.field_name].map(function(block) {
                        if (block.files == undefined || (block.files != undefined && block.files.length == 0))
                          block_empty = true;
                      });
                      if (block_empty)
                        e = e + '(true)';
                    }
                  break;
                }
              });

              if (eval(e)) {
                _this.errors.push({
                  id: field.name,
                  msg: criterion.description
                });
              }
            }
          });
        }
      }

      if (this.errors.length > 0) {
        $('body, html').animate({'scrollTop': $('#'+this.errors[0].id).offset().top - 30});
        return;
      }

      // Form mező definíciók kitörlése
      var form_data = JSON.parse(JSON.stringify(this.form));
      delete form_data.fields;

      this.$root.ajax('form/fillsave/', {
        method: 'POST',
        data: {
          form: JSON.stringify(form_data),
          finalize: 1
        },
        success: function(response) {
          if (response.error) {
            alert(response.error);

          } else {
            _this.hasFill = true;
          }
        }
      });
    },

    preSave: function() {
      var _this = this;

      // Form mező definíciók kitörlése
      var form_data = JSON.parse(JSON.stringify(this.form));
      delete form_data.fields;

      this.$root.ajax('form/fillsave/', {
        method: 'POST',
        data: {
          form: JSON.stringify(form_data),
          finalize: 0
        },
        success: function(response) {
          if (response.error) {
            alert(response.error);

          } else {
            _this.form.thanx_msg = 'Az űrlap kitöltés elmentve.';
            _this.hasFill = true;
          }
        }
      });
    }
  }
});

Vue.component('Nyelvvizsgak', {
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      nyelvvizsgak: []
    }
  },
  template: `
    <div class="form-group disabled">
      <label class="form-label">{{ label }}</label>
      <div class="form-checkbox-wrapper" v-for="(nyelvvizsga, i) in nyelvvizsgak">
        <input type="checkbox" checked="checked" disabled/>
        <label>
          <div class="icon"></div>
          {{ nyelvvizsga.f1 }} {{ nyelvvizsga.f3 }} {{ nyelvvizsga.f2 }}
        </label>
      </div>
    </div>
  `,
  mounted: function() {
    var _this = this;

    this.$root.ajax('hallgato_nyelvvizsgak/', {
      success: function(response) {
        if (response.error == false) {
          _this.nyelvvizsgak = response.nyelvvizsgak;

          var values = [];
          _this.nyelvvizsgak.map(function(nyelvvizsga) {
            values.push(nyelvvizsga.f1 + ' ' + nyelvvizsga.f3 + ' ' + nyelvvizsga.f2);
          });

          _this.$emit('ready', values);

        } else {
          alert(response.error);
        }
      }
    });
  }
});

Vue.component('TMDK', {
  props: {
    label: {
      type: String,
      required: true
    },
    accepted_files: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      required: true
    },
    szakkod: {
      type: String,
      required: false
    },
    max_uploaded_files: {
      type: Number,
      required: false,
      default: 1
    },
    loaded_data: {
      type: [String, Array],
      required: false
    }
  },
  data: function() {
    return {
      options: [],
      ld: [],
      loaded: false
    }
  },
  template: `
    <div v-show="options.length > 0">
      <UploadHandlerWithComboAddRemove :hide_point="true" :block_once="true" :errors="errors" :max_uploaded_files="max_uploaded_files" v-on:change="uploadHandlerChange" :accepted_files="accepted_files" :options="options" :id="id" :label="label" :name="id" :ref="'uh_'+id"/>
    </div>
  `,
  watch: {
    loaded_data: {
      immediate: true,
      handler: function() {
        var _this = this;

        if (this.loaded_data != undefined && this.loaded_data != '' && !this.loaded) {
          this.loaded = true;
          this.ld = this.loaded_data;
        }
      }
    },
    szakkod: function() {
      if (this.szakkod != undefined && this.szakkod != '')
        this.getOptions();
    }
  },
  mounted: function() {

  },
  methods: {
    uploadHandlerChange: function(value) {
      this.$emit('change', value);
    },
    getOptions: function() {
      var _this = this;

      this.$root.ajax('hallgato_tmdk/', {
        data: {
          szakkod: this.szakkod
        },
        method: 'POST',
        success: function(response) {
          if (response.error == false) {
            // Előző feltöltések törlése szakváltás esetén
            if (_this.ld == '')
              _this.$refs['uh_'+_this.id].reset();

            _this.options = response.tmdks;

            if (_this.ld != '') {
              setTimeout(function() {
                _this.ld.map(function(d) {
                  _this.$refs['uh_'+_this.id].addBlockFromOuter(d.id, d.label, d.files);
                });
                _this.ld = '';
              }, 0);
            }

          } else {
            alert(response.error);
          }
        }
      });
    }
  }
});

Vue.component('OTDK', {
  props: {
    label: {
      type: String,
      required: true
    },
    accepted_files: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      required: true
    },
    szakkod: {
      type: String,
      required: true
    },
    loaded_data: {
      type: [String, Array],
      required: false
    }
  },
  data: function() {
    return {
      options: [],
      ld: [],
      loaded: false
    }
  },
  template: `
    <div v-show="options.length > 0">
      <UploadHandlerWithComboAddRemove :hide_point="true" :block_once="true" :errors="errors" max_uploaded_files="5" v-on:change="uploadHandlerChange" :accepted_files="accepted_files" :options="options" :id="id" :label="label" :name="id" :ref="'otdk_uh_'+id"/>
    </div>
  `,
  watch: {
    loaded_data: {
      immediate: true,
      handler: function() {
        var _this = this;

        if (this.loaded_data != undefined && this.loaded_data != '' && !this.loaded) {
          this.loaded = true;
          this.ld = this.loaded_data;
        }
      }
    },
    szakkod: function() {
      this.getOptions();
    }
  },
  mounted: function() {

  },
  methods: {
    uploadHandlerChange: function(value) {
      this.$emit('change', value);
    },
    getOptions: function() {
      var _this = this;

      this.$root.ajax('hallgato_otdk/', {
        data: {
          szakkod: this.szakkod
        },
        method: 'POST',
        success: function(response) {
          if (response.error == false) {
            // Előző feltöltések törlése szakváltás esetén
            if (_this.ld == '')
              _this.$refs['otdk_uh_'+_this.id].reset();

            _this.options = response.otdks;

            if (_this.ld != '') {
              setTimeout(function() {
                _this.ld.map(function(d) {
                  _this.$refs['otdk_uh_'+_this.id].addBlockFromOuter(d.id, d.label, d.files);
                });
                _this.ld = '';
              }, 0);
            }

          } else {
            alert(response.error);
          }
        }
      });
    }
  }
});

Vue.component('Szak', {
  props: {
    label: {
      type: String,
      required: true
    },
    academic_year: {
      type: String,
      required: true
    },
    semester: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    },
    default_value: {
      type: String,
      required: false
    },
    utolso_lezart_felev_osztondij_indexe_p: {
      type: [String, Number],
      required: false
    },
    lezart_felevek_p: {
      type: [String, Number],
      required: false
    },
    errors: {
      type: Array,
      required: true,
      default: []
    }
  },
  data: function() {
    return {
      szakkod: '',
      szakok: [],
      utolso_elotti_lezart_felev_osztondij_indexe: 0,
      utolso_lezart_felev_osztondij_indexe: 0,
      atlag: 0,
      lezart_felevek: 0,
      szakirany: '',
      szakmegnevezes: '',
      kar: '',
      tanulmanyi_statusz: '',
      utolso_lezart_felev_osztondij_indexe_d: true,
      lezart_felevek_d: true,
      df: ''
    }
  },
  template: `
    <div>
      <div class="form-group">
        <label class="form-label">{{ label }}</label>
        <select @change="changeSzakkod" class="form-control" id="szakkod" v-model="szakkod">
          <option v-for="szak in szakok" :value="szak.szakkod">{{ szak.szak }} {{ szak.kepzes_szint }} ({{ szak.tagozat }})</option>
        </select>
        <div v-if="error.id == 'szakkod'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
      </div>
      <div class="form-group">
        <label class="form-label">Szakirány</label>
        <input disabled="disabled" type="text" v-model="szakirany" class="form-control">
      </div>
      <div class="form-group">
        <label class="form-label">Kar</label>
        <input disabled="disabled" type="text" v-model="kar" class="form-control">
      </div>
      <div class="row">
        <div v-show="df.utolso_elotti_lezart_felev_osztondij_indexe == 1 ? true : false" class="col-xs-4">
          <div class="form-group">
            <label class="form-label">Utolsó előtti lezárt félév ösztöndíj indexe</label>
            <input disabled="disabled" type="text" v-model="utolso_elotti_lezart_felev_osztondij_indexe" class="form-control">
          </div>
        </div>
        <div v-show="df.utolso_lezart_felev_osztondij_indexe == 1 ? true : false" class="col-xs-4">
          <inputbox :disabled="utolso_lezart_felev_osztondij_indexe_d" @input="emitChange" regexp_filter="[0-9.]+" id="utolso_lezart_felev_osztondij_indexe" label="Utolsó lezárt félév ösztöndíj indexe" name="utolso_lezart_felev_osztondij_indexe" v-model="utolso_lezart_felev_osztondij_indexe"/>
        </div>
        <div v-show="df.atlag == 1 ? true : false" class="col-xs-2">
          <div class="form-group">
            <label class="form-label">Átlag</label>
            <input disabled="disabled" type="text" v-model="atlag" class="form-control">
          </div>
        </div>
        <div class="col-xs-2" v-show="df.lezart_felevek == 1 ? true : false">
          <inputbox :errors="errors" :disabled="lezart_felevek_d" @input="emitChange" regexp_filter="[0-9]+" id="lezart_felevek" label="Lezárt félévek" name="lezart_felevek" v-model="lezart_felevek"/>
        </div>
      </div>
      <div class="form-group" v-show="df.tanulmanyi_statusz == 1 ? true : false">
        <label class="form-label">Tanulmányi státusz</label>
        <input disabled="disabled" type="text" v-model="tanulmanyi_statusz" class="form-control">
        <div v-if="error.id == 'tanulmanyi_statusz'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
      </div>
    </div>
  `,
  watch: {
    value: {
      immediate: true,
      handler: function() {
        this.szakkod = this.value;
        this.setAtlagok();
      }
    }
  },
  mounted: function() {
    var _this = this;

    Vue.nextTick(function() {
      if (_this.default_value != undefined && _this.default_value != '') {
        _this.df = JSON.parse(_this.default_value);
      }

      _this.szakkod = _this.value;

      _this.$root.ajax('hallgato_szakok/', {
        data: {
          academic_year: _this.academic_year,
          semester: _this.semester
        },
        method: 'POST',
        success: function(response) {
          if (response.error == false) {
            _this.szakok = response.szakok;

            if (_this.value == '') {
              _this.szakkod = _this.szakok[0].szakkod;
            } else {
              _this.szakkod = _this.value;
            }

            _this.setAtlagok(true);

          } else {
            swal("Hiba!",response.error,"error");
          }
        }
      });
    });
  },
  methods: {
    setAtlagok: function(elso_hivas) {
      var _this = this;
      var szakir_nevek = [];

      if (this.szakok.length > 0) {
        this.szakok.map(function(szak) {
          if (szak.szakkod == _this.szakkod) {
            _this.utolso_lezart_felev_osztondij_indexe = szak.atlagok.felev2;
            _this.utolso_elotti_lezart_felev_osztondij_indexe = szak.atlagok.felev1;
            _this.atlag = szak.atlagok.atlag;
            _this.lezart_felevek = szak.lezart_felevek_szama;
            _this.kar = szak.kar;
            _this.tanulmanyi_statusz = szak.statusz;
            szak.szakirany.map(function(szakir) {
              szakir_nevek.push(szakir.szakirany_nev);
            });
            _this.szakirany = szakir_nevek.join("; ");
            _this.szakmegnevezes = szak.szak + ' ' + szak.kepzes_szint + ' ' + szak.tagozat;

            if (szak.kepzes_szint == 'mesterképzés (MA/MSc)') {
              _this.utolso_lezart_felev_osztondij_indexe_d = false;
              _this.lezart_felevek_d = false;

              if (elso_hivas && _this.utolso_lezart_felev_osztondij_indexe_p != undefined && _this.utolso_lezart_felev_osztondij_indexe_p != '') {
                _this.utolso_lezart_felev_osztondij_indexe = _this.utolso_lezart_felev_osztondij_indexe_p;
              }

              if (elso_hivas && _this.lezart_felevek_p != undefined && _this.lezart_felevek_p != '') {
                _this.lezart_felevek = _this.lezart_felevek_p;
              }

            } else {
              _this.utolso_lezart_felev_osztondij_indexe_d = true;
              _this.lezart_felevek_d = true;
            }
          }
        });
        this.emitChange();
      }
    },

    emitChange: function() {
      this.$emit('change', this.szakkod, this.atlag, this.lezart_felevek, this.utolso_lezart_felev_osztondij_indexe, this.utolso_elotti_lezart_felev_osztondij_indexe, this.tanulmanyi_statusz, this.szakmegnevezes, this.kar);
    },

    changeSzakkod: function() {
      this.setAtlagok(false);
    }
  }
});

Vue.component('SzakKreditSzammal', {
  props: {
    label: {
      type: String,
      required: true
    },
    academic_year: {
      type: String,
      required: true
    },
    semester: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    },
    default_value: {
      type: String,
      required: false
    },
    errors: {
      type: Array,
      required: true,
      default: []
    },
    childs: {
      type: Array,
      required: true,
      default: []
    }
  },
  data: function() {
    return {
      szakkod: '',
      szakok: [],
      utolso_elotti_lezart_felev_osztondij_indexe: 0,
      utolso_lezart_felev_osztondij_indexe: 0,
      atlag: 0,
      lezart_felevek: 0,
      szakirany: '',
      szakmegnevezes: '',
      kar: '',
      tanulmanyi_statusz: '',
      utolso_felev_telj_kredit: 0,
      utolso_felev_felvett_kredit: 0,
      kreditek_szama: 0,
      df: ''
    }
  },
  template: `
    <div>
      <div class="form-group">
        <label class="form-label">{{ label }}</label>
        <select @change="changeSzakkod" class="form-control" v-model="szakkod">
          <option v-for="szak in szakok" :value="szak.szakkod">{{ szak.szak }} {{ szak.kepzes_szint }} ({{ szak.tagozat }})</option>
        </select>
      </div>
      <div class="form-group">
        <label class="form-label">Szakirány</label>
        <input disabled="disabled" type="text" v-model="szakirany" class="form-control">
      </div>
      <div class="form-group">
        <label class="form-label">{{ getLabel('kar') }}</label>
        <input disabled="disabled" type="text" v-model="kar" class="form-control">
      </div>
      <div class="row">
        <div class="col-xs-4" v-show="df.utolso_elotti_lezart_felev_osztondij_indexe == 1 ? true : false">
          <div class="form-group">
            <label class="form-label">{{ getLabel('utolso_elotti_lezart_felev_osztondij_indexe') }}</label>
            <input disabled="disabled" type="text" v-model="utolso_elotti_lezart_felev_osztondij_indexe" class="form-control">
            <div v-if="error.id == 'utolso_elotti_lezart_felev_osztondij_indexe'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>
        <div class="col-xs-4" v-show="df.utolso_lezart_felev_osztondij_indexe == 1 ? true : false">
          <div class="form-group">
            <label class="form-label">{{ getLabel('utolso_lezart_felev_osztondij_indexe') }}</label>
            <input disabled="disabled" type="text" v-model="utolso_lezart_felev_osztondij_indexe" class="form-control">
            <div v-if="error.id == 'utolso_lezart_felev_osztondij_indexe'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>
        <div class="col-xs-4" v-show="df.atlag == 1 ? true : false">
          <div class="form-group">
            <label class="form-label">{{ getLabel('atlag') }}</label>
            <input disabled="disabled" type="text" v-model="atlag" class="form-control">
            <div v-if="error.id == 'atlag'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2" v-show="df.lezart_felevek == 1 ? true : false">
          <div class="form-group">
            <label class="form-label">{{ getLabel('lezart_felevek') }}</label>
            <input disabled="disabled" type="text" v-model="lezart_felevek" class="form-control">
            <div v-if="error.id == 'lezart_felevek'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>
        <div class="col-xs-2" v-show="df.kreditek_szama == 1 ? true : false">
          <div class="form-group">
            <label class="form-label">{{ getLabel('kreditek_szama') }}</label>
            <input disabled="disabled" type="text" v-model="kreditek_szama" class="form-control">
            <div v-if="error.id == 'kreditek_szama'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>
        <div class="col-xs-4" v-show="df.utolso_felev_felvett_kredit == 1 ? true : false">
          <div class="form-group">
            <label class="form-label">{{ getLabel('utolso_felev_felvett_kredit') }}</label>
            <input disabled="disabled" type="text" v-model="utolso_felev_felvett_kredit" class="form-control">
            <div v-if="error.id == 'utolso_felev_felvett_kredit'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>
        <div class="col-xs-4" v-show="df.utolso_felev_telj_kredit == 1 ? true : false">
          <div class="form-group">
            <label class="form-label">{{ getLabel('utolso_felev_telj_kredit') }}</label>
            <input disabled="disabled" type="text" v-model="utolso_felev_telj_kredit" class="form-control">
            <div v-if="error.id == 'utolso_felev_telj_kredit'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>
        <div class="col-xs-4" v-show="df.tanulmanyi_statusz == 1 ? true : false">
          <div class="form-group">
            <label class="form-label">{{ getLabel('tanulmanyi_statusz') }}</label>
            <input disabled="disabled" type="text" v-model="tanulmanyi_statusz" class="form-control">
            <div v-if="error.id == 'tanulmanyi_statusz'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>
      </div>
    </div>
  `,
  watch: {
    value: {
      immediate: true,
      handler: function() {
        this.szakkod = this.value;
        this.setAtlagok();
      }
    }
  },
  mounted: function() {
    var _this = this;

    Vue.nextTick(function() {
      if (_this.default_value != undefined && _this.default_value != '') {
        _this.df = JSON.parse(_this.default_value);
      }

      _this.szakkod = _this.value;

      _this.$root.ajax('hallgato_szakok/', {
        data: {
          academic_year: _this.academic_year,
          semester: _this.semester
        },
        method: 'POST',
        success: function(response) {
          if (response.error == false) {
            _this.szakok = response.szakok;

            if (_this.value == '') {
              _this.szakkod = _this.szakok[0].szakkod;
            } else {
              _this.szakkod = _this.value;
            }

            _this.setAtlagok();

          } else {
            swal("Hiba!",response.error,"error");
          }
        }
      });
    });
  },
  methods: {
    setAtlagok: function() {
      var _this = this;
      var szakir_nevek = [];

      if (this.szakok.length > 0) {
        this.szakok.map(function(szak) {
          if (szak.szakkod == _this.szakkod) {
            _this.utolso_lezart_felev_osztondij_indexe = szak.atlagok.felev2;
            _this.utolso_elotti_lezart_felev_osztondij_indexe = szak.atlagok.felev1;
            _this.atlag = szak.atlagok.atlag;
            _this.lezart_felevek = szak.lezart_felevek_szama;
            _this.kar = szak.kar;
            _this.tanulmanyi_statusz = szak.statusz;
            _this.kreditek_szama = szak.kreditek_szama;
            _this.utolso_felev_telj_kredit = szak.utolso_felev_telj_kredit;
            _this.utolso_felev_felvett_kredit = szak.utolso_felev_felvett_kredit;
            szak.szakirany.map(function(szakir) {
              szakir_nevek.push(szakir.szakirany_nev);
            });
            _this.szakirany = szakir_nevek.join("; ");
            _this.szakmegnevezes = szak.szak + ' ' + szak.kepzes_szint + ' ' + szak.tagozat;
          }
        });

        this.$emit('change', this.szakkod, this.atlag, this.lezart_felevek, this.utolso_lezart_felev_osztondij_indexe, this.utolso_elotti_lezart_felev_osztondij_indexe, this.tanulmanyi_statusz, this.szakmegnevezes, this.kreditek_szama, this.kar, this.utolso_felev_telj_kredit, this.utolso_felev_felvett_kredit);
      }
    },

    getLabel: function(name) {
      var label = '';

      if (this.childs.length > 0) {
        this.childs.map(function(child) {
          if (name == child.name) {
            label = child.label;
          }
        });
      }

      return label;
    },

    changeSzakkod: function() {
      this.setAtlagok();
    }
  }
});

Vue.component('MegelhetesiTamogatasSzak', {
  props: {
    label: {
      type: String,
      required: true
    },
    academic_year: {
      type: String,
      required: true
    },
    semester: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      szakkod: '',
      szakok: [],
      szakirany: '',
      kar: '',
      aktiv_felevek_szama: 0,
      passziv_felevek_szama: 0,
      tagozat: '',
      tanulmanyi_statusz: '',
      penzugyi_statusz: ''
    }
  },
  template: `
    <div>
      <div class="form-group">
        <label class="form-label">{{ label }}</label>
        <select @change="changeSzakkod" class="form-control" v-model="szakkod">
          <option v-for="szak in szakok" :value="szak.szakkod">{{ szak.szak }} {{ szak.kepzes_szint }} ({{ szak.tagozat }}) ({{ szak.szakkod }})</option>
        </select>
      </div>
      <div class="form-group">
        <label class="form-label">Szakirány</label>
        <input disabled="disabled" type="text" v-model="szakirany" class="form-control">
      </div>
      <div class="form-group">
        <label class="form-label">Kar</label>
        <input disabled="disabled" type="text" v-model="kar" class="form-control">
      </div>
      <div class="row">
        <div class="col-xs-4">
          <div class="form-group">
            <label class="form-label">Aktív félévek száma</label>
            <input disabled="disabled" type="text" v-model="aktiv_felevek_szama" class="form-control">
          </div>
        </div>
        <div class="col-xs-4">
          <div class="form-group">
            <label class="form-label">Passzív félévek száma</label>
            <input disabled="disabled" type="text" v-model="passziv_felevek_szama" class="form-control">
          </div>
        </div>
        <div class="col-xs-4">
          <div class="form-group">
            <label class="form-label">Tagozat</label>
            <input disabled="disabled" type="text" v-model="tagozat" class="form-control">
          </div>
        </div>
        <div class="col-xs-6">
          <div class="form-group">
            <label class="form-label">Tanulmányi státusz</label>
            <input disabled="disabled" type="text" v-model="tanulmanyi_statusz" class="form-control">
          </div>
        </div>
        <div class="col-xs-6">
          <div class="form-group">
            <label class="form-label">Pénzügyi státusz</label>
            <input disabled="disabled" type="text" v-model="penzugyi_statusz" class="form-control">
          </div>
        </div>
      </div>
    </div>
  `,
  watch: {
    value: {
      immediate: true,
      handler: function() {
        this.szakkod = this.value;
        this.setAdatok();
      }
    }
  },
  mounted: function() {
    var _this = this;

    Vue.nextTick(function() {
      _this.szakkod = _this.value;

      _this.$root.ajax('hallgato_szakok/', {
        data: {
          academic_year: _this.academic_year,
          semester: _this.semester
        },
        method: 'POST',
        success: function(response) {
          if (response.error == false) {
            _this.szakok = response.szakok;

            if (_this.value == '') {
              _this.szakkod = _this.szakok[0].szakkod;
            } else {
              _this.szakkod = _this.value;
            }

            _this.setAdatok();

          } else {
            swal("Hiba!",response.error,"error");
          }
        }
      });
    });
  },
  methods: {
    setAdatok: function() {
      var _this = this;
      var szakir_nevek = [];

      if (this.szakok.length > 0) {
        this.szakok.map(function(szak) {
          if (szak.szakkod == _this.szakkod) {
            _this.kar = szak.kar;
            _this.aktiv_felevek_szama = szak.aktiv_felevek_szama;
            _this.passziv_felevek_szama = szak.passziv_felevek_szama;
            _this.tagozat = szak.tagozat;
            _this.tanulmanyi_statusz = szak.statusz;
            _this.penzugyi_statusz = szak.penzugyi_statusz;

            szak.szakirany.map(function(szakir) {
              szakir_nevek.push(szakir.szakirany_nev);
            });
            _this.szakirany = szakir_nevek.join("; ");

            _this.szakmegnevezes = szak.szak + ' ' + szak.kepzes_szint + ' ' + szak.tagozat;
          }
        });
        this.$emit('change', this.szakkod, this.kar, this.aktiv_felevek_szama, this.passziv_felevek_szama, this.tagozat, this.tanulmanyi_statusz, this.penzugyi_statusz, this.szakirany, this.szakmegnevezes);
      }
    },

    changeSzakkod: function() {
      this.setAdatok();
    }
  }
});

Vue.component('SzocialisPontszam', {
  props: {
    label: {
      type: String,
      required: true
    },
    academic_year: {
      type: String,
      required: true
    },
    semester: {
      type: String,
      required: true
    },
    kepzes_kod: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: false
    },
    default_value: {
      type: [String, Number],
      required: false
    },
    errors: {
      type: Array,
      required: true,
      default: []
    }
  },
  data: function() {
    return {
      pontszam: 0
    }
  },
  template: `
    <div>
      <div class="form-group">
        <label class="form-label">{{ label }}</label>
        <input disabled="disabled" type="text" v-model="pontszam" class="form-control">
      </div>
    </div>
  `,
  watch: {
    value: {
      immediate: true,
      handler: function() {
        this.pontszam = this.value;
      }
    },
    kepzes_kod: {
      immediate: true,
      handler: function() {
        if (this.kepzes_kod != '')
          this.getPontszam();
      }
    }
  },
  mounted: function() {
    var _this = this;
  },
  methods: {
    getPontszam: function() {
      var _this = this;

      this.$root.ajax('form/rendszeres_szocialis_osztondij_pontszam/', {
        data: {
          academic_year: _this.academic_year,
          semester: _this.semester,
          kepzes_kod: _this.kepzes_kod
        },
        method: 'POST',
        success: function(response) {
          if (response.error == false) {
            _this.pontszam = response.pontszam;
            _this.$emit('change', _this.pontszam);

          } else {
            swal("Hiba!",response.error,"error");
          }
        }
      });
    }
  }
});

Vue.component('FormSection', {
  props: ['form', 'field', 'childs', 'errors'],
  data: function() {
    return {

    };
  },
  template: `
    <div v-if="showField(field, 'Szekció')" style="border:1px dotted #ccc; padding: 10px;">
      <div v-for="(item, i) in childs">
        <inputbox :placeholder="item.placeholder != '' ? item.placeholder : ''" :mask="item.inputmask != '' ? item.inputmask : ''" :regexp_filter="item.regexp_filter != undefined ? item.regexp_filter : ''" :maxlength="item.maxlength != undefined ? item.maxlength : ''" :errors="errors" :id="item.name" v-if="showField(item, 'Szövegmező')" :label="item.label" :name="item.name" v-model="form.values[item.name]"/>

        <inputbox :errors="errors" :datepickeropts="{'yearRange':'-100:+0','changeYear':'true','changeMonth':'true'}" :id="item.name" :datepicker="true" v-if="showField(item, 'Dátum')" :label="item.label" :name="item.name" v-model="form.values[item.name]"/>

        <textareabox :errors="errors" :id="item.name" v-if="showField(item, 'Szövegdoboz')" :label="item.label" :name="item.name" v-model="form.values[item.name]"/>

        <div v-if="showField(item, 'Legördülő')" class="form-group">
          <label class="form-label">{{ item.label }}</label>
          <select v-on:change="comboChange(item.name, form.values[item.name])" class="form-control" :name="item.name" :id="item.name" v-model="form.values[item.name]">
            <option v-if="option.show == 1" v-for="(option, i) in item.options" :value="option.value">{{ option.text }}</option>
          </select>
          <div v-if="error.id == item.name" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
        </div>

        <UploadHandlerWithCombo :ref="item.name" v-on:change="(value) => { changeValue(value, item.name); }" :accepted_files="item.accepted_files" v-if="showField(item, 'Kategorizált fájlfeltöltő')" :options="item.options" :errors="errors" :id="item.name" :label="item.label" :name="item.name"/>

        <div v-if="showField(item, 'Paragrafus')" class="form-group">
          <div class="form-paragraph">
            <p v-if="item.default_value != ''" v-html="item.default_value"></p>
          </div>
        </div>

        <div v-if="showField(item, 'Infóblokk')" class="info-box warning" v-html="item.default_value"></div>

        <div v-if="showField(item, 'Alcím')" class="form-group">
          <h2 v-if="item.label != ''">{{ item.label }}</h2>
        </div>

        <div v-if="showField(item, 'Jelölőnégyzet csoport')" class="form-group">
          <label class="form-label">{{ item.label }}</label>
          <div v-if="option.show == 1" class="form-checkbox-wrapper" v-for="(option, i) in item.options">
            <input :id="item.name+'_'+i" :name="item.name+'_'+i" type="checkbox" :value="option.value" v-model="form.values[item.name]"/>
            <label :for="item.name+'_'+i">
              <div class="icon"></div>
              {{ option.text }}
            </label>
          </div>
          <div v-if="error.id == item.name" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
        </div>

        <div v-if="showField(item, 'Jelölőnégyzet')" class="form-group">
          <label class="form-label" v-html="item.label"></label>
          <div class="form-checkbox-wrapper">
            <input :id="item.name" :name="item.name" type="checkbox" :value="item.value" v-model="form.values[item.name]"/>
            <label :for="item.name">
              <div class="icon"></div>
            </label>
          </div>
          <div v-if="error.id == item.name" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
        </div>

        <div v-if="showField(item, 'Rádiógomb csoport')" class="form-group">
          <label class="form-label">{{ item.label }}</label>
          <div v-if="option.show == 1" class="form-radiobox-wrapper" v-for="(option, i) in item.options">
            <input :id="item.name+'_'+i" :name="item.name+'_'+i" type="radio" :value="option.value" v-model="form.values[item.name]"/>
            <label :for="item.name+'_'+i">
              <div class="icon"></div>
              {{ option.text }}
            </label>
          </div>
          <div v-if="error.id == item.name" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
        </div>

        <UploadHandler v-on:change="(value) => { changeValue(value, item.name); }" :accepted_files="item.accepted_files" v-if="showField(item, 'Fájlfeltöltés')" :errors="errors" :id="item.name" :label="item.label" :key="item.name" :name="item.name" :default_value="item.default_value" :loaded_files="form.values[item.name]"/>

        <Nyelvvizsgak v-on:ready="(value) => { changeValue(value, item.name); }" :key="item.name" v-if="showField(item, 'Nyelvvizsgák')" :label="item.label"/>

        <Szak :errors="errors" v-on:change="(szakkod, atlag, lezart_felevek, utolso_lezart_felev_osztondij_indexe, utolso_elotti_lezart_felev_osztondij_indexe, tanulmanyi_statusz, szakmegnevezes, kar) => { changeValue(szakkod, item.name); changeValue(atlag, 'atlag'); changeValue(lezart_felevek, 'lezart_felevek'); changeValue(utolso_lezart_felev_osztondij_indexe, 'utolso_lezart_felev_osztondij_indexe'); changeValue(utolso_elotti_lezart_felev_osztondij_indexe, 'utolso_elotti_lezart_felev_osztondij_indexe'); changeValue(tanulmanyi_statusz, 'tanulmanyi_statusz'); changeValue(szakmegnevezes, 'szakmegnevezes'); changeValue(kar, 'kar'); }" :key="item.name" v-if="showField(item, 'Szak')" :label="item.label" :academic_year="form.academic_year" :semester="form.semester" :default_value="item.default_value" :utolso_lezart_felev_osztondij_indexe_p="form.values.utolso_lezart_felev_osztondij_indexe" :lezart_felevek_p="form.values.lezart_felevek" v-model="form.values[item.name]"/>

        <SzakKreditSzammal :childs="childs" :errors="errors" v-on:change="(szakkod, atlag, lezart_felevek, utolso_lezart_felev_osztondij_indexe, utolso_elotti_lezart_felev_osztondij_indexe, tanulmanyi_statusz, szakmegnevezes, kreditek_szama, kar, utolso_felev_telj_kredit, utolso_felev_felvett_kredit) => { changeValue(szakkod, item.name); changeValue(atlag, 'atlag'); changeValue(lezart_felevek, 'lezart_felevek'); changeValue(utolso_lezart_felev_osztondij_indexe, 'utolso_lezart_felev_osztondij_indexe'); changeValue(utolso_elotti_lezart_felev_osztondij_indexe, 'utolso_elotti_lezart_felev_osztondij_indexe'); changeValue(tanulmanyi_statusz, 'tanulmanyi_statusz'); changeValue(szakmegnevezes, 'szakmegnevezes'); changeValue(kreditek_szama, 'kreditek_szama'); changeValue(kar, 'kar'); changeValue(utolso_felev_telj_kredit, 'utolso_felev_telj_kredit'); changeValue(utolso_felev_felvett_kredit, 'utolso_felev_felvett_kredit'); }" :key="item.name" v-if="showField(item, 'SzakKreditSzammal')" :label="item.label" :academic_year="form.academic_year" :semester="form.semester" :default_value="item.default_value" v-model="form.values[item.name]"/>

        <MegelhetesiTamogatasSzak v-on:change="(szakkod, kar, aktiv_felevek_szama, passziv_felevek_szama, tagozat, tanulmanyi_statusz, penzugyi_statusz, szakirany, szakmegnevezes) => { changeValue(szakkod, item.name); changeValue(kar, 'kar'); changeValue(aktiv_felevek_szama, 'aktiv_felevek_szama'); changeValue(passziv_felevek_szama, 'passziv_felevek_szama'); changeValue(tagozat, 'tagozat'); changeValue(tanulmanyi_statusz, 'tanulmanyi_statusz'); changeValue(penzugyi_statusz, 'penzugyi_statusz'); changeValue(szakirany, 'szakirany'); changeValue(szakmegnevezes, 'szakmegnevezes'); }" :key="item.name" v-if="showField(item, 'MegelhetesiTamogatasSzak')" :label="item.label" :academic_year="form.academic_year" :semester="form.semester" v-model="form.values[item.name]"/>

        <TMDK v-on:change="(value) => { changeValue(value, item.name); }" :szakkod="form.values.szakkod" :key="item.name" :id="item.name" v-if="showField(item, 'TMDK')" :label="item.label" :errors="errors" :loaded_data="form.values[item.name]" :accepted_files="item.accepted_files"/>

        <SzocialisPontszam v-on:change="(value) => { changeValue(value, item.name); }" :key="item.name" v-if="showField(item, 'Szociális pontszám')" :label="item.label" :errors="errors" :academic_year="form.academic_year" :semester="form.semester" :kepzes_kod="form.values.szakkod" v-model="form.values[item.name]"/>

        <div v-if="showField(item, 'GDPR elfogadás')">
          <div class="form-group">
            <label class="form-label">{{ item.label }}</label>
            <div class="form-scroll-block" v-html="$root.nl2br(item.default_value)"></div>
          </div>
          <div class="form-group">
            <div class="form-checkbox-wrapper">
              <input id="gdpr_elfogadas" name="gdpr_elfogadas" type="checkbox" value="1" v-model="form.values.gdpr_elfogadas"/>
              <label for="gdpr_elfogadas">
                <div class="icon"></div>
                Nyilatkozat elfogadása
              </label>
            </div>
            <div v-if="error.id == item.name" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>

        <div v-if="showField(item, 'Gomb')" class="form-group">
          <button v-on:click="saveClick" class="button" type="button">{{ item.label }}</button>
        </div>

        <div v-if="showField(item, 'Infódoboz')" class="form-group">
          <div class="info-box warning" style="margin-bottom: 0px" v-html="item.default_value"></div>
        </div>

        <div v-if="showField(item, 'Mentés és véglegesít gomb')" class="form-group" style="display: flex; justify-content: space-between">
          <button v-on:click="preSaveClick" class="button" type="button">Mentés</button>
          <button v-on:click="saveClick" class="button" type="button">Véglegesít</button>
        </div>
        <FormSection :errors="errors" v-on:saveClick="saveClick" v-on:preSaveClick="preSaveClick" :key="item.name" v-if="item.childs.length > 0" :form="form" :field="item" :childs="item.childs"></FormSection>
      </div>
    </div>
  `,
  mounted: function() {
  },
  methods: {
    changeValue: function(value, name) {
      this.form.values[name] = value;
    },

    saveClick: function() {
      this.$emit('saveClick');
    },

    preSaveClick: function() {
      this.$emit('preSaveClick');
    },

    showField: function(field, type) {
      var _this = this;
      var r = false;

      if (field.type == type) {
        if (field.criterions != undefined) {
          r = true;

          field.criterions.map(function(criterion) {
            if (criterion.type == 'Megjelenés') {
              var e = '';

              criterion.items.map(function(item) {
                switch(item.criterion_name) {
                  case "Zárójel nyit":
                    e = e + "(";
                  break;
                  case "Zárójel zár":
                    e = e + ")";
                  break;
                  case "Kitöltött":
                    e = e + "(_this.form.values."+item.field_name+" != '' && _this.form.values."+item.field_name+" != 0)";
                  break;
                  case "Nem kitöltött":
                    e = e + "(_this.form.values."+item.field_name+" == '' || _this.form.values."+item.field_name+" == 0)";
                  break;
                  case "Egyenlő":
                    e = e + "_this.form.values."+item.field_name+" == " + item.value;
                  break;
                  case "Nem egyenlő":
                    e = e + "_this.form.values."+item.field_name+" != " + item.value;
                  break;
                  case "Kisebb mint":
                    e = e + "_this.form.values."+item.field_name+" < " + item.value;
                  break;
                  case "Nagyobb mint":
                    e = e + "_this.form.values."+item.field_name+" > " + item.value;
                  break;
                  case "Kisebb egyenlő":
                    e = e + "_this.form.values."+item.field_name+" <= " + item.value;
                  break;
                  case "Nagyobb egyenlő":
                    e = e + "_this.form.values."+item.field_name+" >= " + item.value;
                  break;
                  case "Igaz":
                    e = e + "_this.form.values."+item.field_name+" == true";
                  break;
                  case "Hamis":
                    e = e + "_this.form.values."+item.field_name+" == false";
                  break;
                  case "Tartalmaz":
                    e = e + "jQuery.inArray('"+item.value+"', _this.form.values."+item.field_name+") > -1";
                  break;
                  case "Nem tartalmaz":
                    e = e + "jQuery.inArray('"+item.value+"', _this.form.values."+item.field_name+") == -1";
                  break;
                  case "Szöveget tartalmaz":
                    e = e + "_this.form.values."+item.field_name+".indexOf('"+item.value+"') > -1";
                  break;
                  case "Szöveget nem tartalmaz":
                    e = e + "_this.form.values."+item.field_name+".indexOf('"+item.value+"') < 0";
                  break;
                  case "És":
                    e = e + " && ";
                  break;
                  case "Vagy":
                    e = e + " || ";
                  break;
                }
              });

              if (eval(e))
                r = true;
              else
                r = false;
            }
          });

        } else {
          r = true;
        }

      } else {
        r = false;
      }

      return r;
    },

    getFieldByName: function(_this, fields, name, f) {
      var _this = _this;

      fields.map(function(field) {
        if (field.name == name)
          f = field;

        if (field.childs.length > 0 && f == false)
          f = _this.getFieldByName(_this, field.childs, name, f);
      });

      return f;
    },

    comboChange: function(name, value) {
      //this.$forceUpdate();

      var _this = this;

      // Mező objektumot visszakéri a névből
      var f = false;

      f = this.getFieldByName(this, this.form.fields, name, false);

      if (f === false)
        return;

      // Opció értékből (value) visszakéri a form_field_options_id-t
      if (f.options == undefined)
        return;

      var o = false;
      f.options.map(function(option) {
        if (option.value == value)
          o = option;
      });

      if (o === false)
        return;

      // "- válasszon -" opciót választotta ki
      if (o.form_field_options_id == 0) {
        // Összes olyan combót nullázza, amely függ ettől a comboboxtól
        this.$root.ajax('form/get_subfields/' + f.form_field_id, {
          method: 'GET',
          success: function(response) {
            if (response.error == false) {
              response.subfields.map(function(subfield) {
                var field = _this.getFieldByName(_this, _this.form.fields, subfield, false);
                field.options = [response.null_opcio];
                _this.form.values[field.name] = 0;
              });
            } else {
              alert(response.error);
            }
          }
        });

      } else {
        // Beállítja a kapcsolódó legördülő comboboxok opcióit
        this.$root.ajax('form/get/options/' + o.form_field_options_id, {
          method: 'GET',
          success: function(response) {
            if (response.options != false) {
              response.options.map(function(o) {
                var field = _this.getFieldByName(_this, _this.form.fields, o.name, false);
                field.options = o.options;
                _this.form.values[field.name] = 0;

                if (field.type == "Kategorizált fájlfeltöltő") {
                  _this.$parent.$refs[field.name][0].changeComboValue(0);
                }
              });
            }
          }
        });
      }
    }
  }
});

Vue.component('UploadHandlerWithComboAddRemove', {
  props: {
    label: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    accepted_files: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    max_uploaded_files: {
      type: [String, Number],
      required: true
    },
    block_point: {
      type: Number,
      required: false,
      default: 0
    },
    block_once: {
      type: Boolean,
      required: false,
      default: false
    },
    hide_point: {
      type: Boolean,
      required: false,
      default: false
    },
    hide_all_options: {
      type: Boolean,
      required: false,
      default: false
    },
    enable_block_delete: {
      type: Boolean,
      required: false,
      default: true
    },
    tooltipDescription: {
      type: String,
      required: false,
      default: ''
    },
    autoFill: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      maxfiles: this.max_uploaded_files == undefined ? 3 : this.max_uploaded_files,
      comboValue: 0,
      blocks: [],
      error: '',
      max_uploaded_filesize_mb: 0,
      max_uploaded_filesize: 0,
      no_option_msg: ''
    };
  },
  template: `
    <div :id="id" class="form-group">
      <label class="form-label">{{ label }} <span v-if="block_point != undefined && !hide_point" style="font-weight:400">({{block_point}} pont)</span><Tooltip v-if="tooltipDescription != ''" :description="tooltipDescription"/></label>
      <div class="info-box warning" v-if="no_option_msg != ''" v-html="no_option_msg"></div>
      <div v-if="no_option_msg == ''" class="form-upload-block" v-for="(block, i) in blocks">
        <div class="form-upload-block-header">
          <h2>{{ block.label }}</h2>
          <a v-if="enable_block_delete" :class="{disabled:block.file_upload_in_progress}" v-on:click="removeBlock(block.id)" href="javascript:void(0)" class="button only-icon"><i class="fa fa-trash-o"></i></a>
        </div>
        <div v-if="(autoFill == undefined || autoFill == false) && block.files.length > 0">
          <div v-for="(file, j) in block.files" class="profile-publication-item">
            <div class="text">
              <i class="fa fa-file-o"></i><a target="_blank" :href="getFilePath(file)">{{ file }}</a>
            </div>
            <div class="links">
              <a v-on:click="deleteUploadedFile(block.id, file)" href="javascript:void(0)" class="link v2"><i class="fa fa-trash-o"></i></a>
            </div>
          </div>
        </div>
        <div :id="block.id" v-show="(autoFill == undefined || autoFill == false) && block.files.length < maxfiles" style="width: 100%; margin-bottom: 10px;" class="upload-zone">
          <svg v-show="block.file_upload_in_progress" class="preloader" width="32" height="32" viewBox="0 0 66 66">
            <circle stroke="#dbdbdb" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
            <circle class="preloader-path" stroke="#68B4AE" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
          </svg>
          <i class="fa fa-cloud-upload"></i>
            Új dokumentum feltöltés
          <span style="text-align:center">Húzza ide a feltöltendő fájlokat. <strong>{{ maxfiles - block.files.length }} fájl</strong> tölthető fel.<br>A feltöltendő fájl mérete maximum <strong>{{ max_uploaded_filesize_mb }} mb</strong> lehet.<br>Feltölthető fájltípusok: <strong>{{ filetypes }}</strong></span>
          <input :name="'name_'+block.id" type="file" />
        </div>
        <div v-if="block.error != ''" class="form-error">{{ block.error }}</div>
      </div>
      <div v-show="!isAllOptionUnselectable()" style="display:flex">
        <select v-on:change="comboChange" style="margin-bottom: 10px" class="form-control" :name="'combo_'+name" :id="'combo_'+name" v-model="comboValue">
          <option v-if="option.show == 1" v-for="(option, i) in options" :value="option.value">{{ option.text }}</option>
        </select>
        <a :class="{disabled: comboValue == 0}" v-on:click="addBlock" href="javascript:void(0)" style="margin-left:10px; display:none" class="button only-icon v2"><i class="fa fa-plus"></i></a>
      </div>
      <div v-if="error != ''" class="form-error">{{ error }}</div>
    </div>
  `,
  computed: {
    filetypes: function() {
      var types = this.accepted_files.split(",");
      var s = [];

      types.map(function(type) {
        if (type == 'image/jpeg')
          s.push('jpg');

        if (type == 'application/pdf' || type == 'application/x-pdf')
          s.push('pdf');

        if (type == 'application/vnd.ms-excel' || type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          s.push('xls (excel)');
      });

      s = s.filter((v, i, a) => a.indexOf(v) === i);
      return s.join(", ");
    }
  },
  watch: {
    errors: function() {
      var _this = this;

      _this.error = '';

      this.blocks.map(function(block) {
        block.error = '';
      });

      if (this.errors == undefined || this.errors.length == 0)
        return '';

      this.errors.map(function(err) {
        if (err.id == _this.id) {
          if (err.block_index != undefined && _this.blocks.length > 0) {
            _this.blocks[err.block_index].error = err.msg;

          } else {
            _this.error = err.msg;
          }
        }
      });
    },
    options: function() {
      if (this.options.length > 0 && this.options[0].value != 0)
        this.options.unshift({
          value: 0,
          show: 1,
          text: '- válasszon -'
        });
    }
  },
  mounted: function() {
    var _this = this;

    this.getMaxUploadedFileSize();

    if (this.options[0] != undefined && this.options[0].value != 0) {
      this.options.unshift({
        value: 0,
        show: 1,
        text: '- válasszon -'
      });

      if (this.hide_all_options) {
        this.options.map(function(option) {
          option.show = 0;
        });
      }
    }
  },
  methods: {
    setNoOptionMsg: function(msg) {
      this.no_option_msg = msg;
    },

    clearNoOptionMsg: function() {
      this.no_option_msg = '';
    },

    isAllOptionUnselectable: function() {
      var r = true;

      this.options.map(function(opt) {
        if (opt.show == 1 && opt.value != 0)
          r = false;
      });

      return r;
    },

    reset: function() {
      var _this = this;

      this.blocks.map(function(block) {
        if (block.dropzone != '')
          block.dropzone.destroy();
      });

      this.options.map(function(opt) {
        if (_this.hide_all_options) {
          opt.show = 0;
        } else {
          opt.show = 1;
        }
      });

      this.blocks = [];
      this.comboValue = 0;
      this.$emit('change', this.getValue());
    },

    getMaxUploadedFileSize: function() {
      var _this = this;

      this.$root.ajax('max_feltoltheto_fajlmeret/', {
        success: function(response) {
          _this.max_uploaded_filesize_mb = response.max_uploaded_filesize_mb;
          _this.max_uploaded_filesize = response.max_uploaded_filesize;
        }
      });
    },

    removeAllBlock: function() {
      var _this = this;

      this.blocks.map(function(block) {
        if (block.dropzone != '')
          block.dropzone.destroy();
      });

      this.blocks = [];
      this.$emit('change', this.getValue());
    },

    removeBlock: function(id) {
      var _this = this;

      swal({
        title: "Biztos törli?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Nem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          var tmp = [];

          _this.blocks.map(function(block) {
            if (block.id != id) {
              tmp.push(block);
            } else {
              if (block.dropzone != '')
                block.dropzone.destroy();

              block.files.map(function(file) {
                _this.deleteFileFromServer(file);
              });

              if (_this.block_once) {
                _this.options.map(function(opt) {
                  if (parseInt(opt.value) == parseInt(block.value)) {
                    opt.show = 1;
                  }
                });
              }
            }
          });
          _this.blocks = tmp;

          _this.$emit('change', _this.getValue());
        }
      });
    },

    addBlock: function(files) {
      var _this = this;

      if (files == undefined)
        files = [];

      if (this.comboValue == 0)
        return;

      var id = this.$root.guid();

      this.blocks.push({
        id: id,
        value: this.comboValue,
        label: this.getComboLabelByValue(this.comboValue),
        files: files,
        selected_files_to_upload_amount: 0,
        dropzone: '',
        error: '',
        file_upload_in_progress: false
      });

      this.$emit('change', this.getValue());

      // Ha blokkot csak egyszer lehet hozzáadni
      if (this.block_once) {
        this.options.map(function(opt) {
          if (parseInt(opt.value) == parseInt(_this.comboValue)) {
            opt.show = 0;
          }
        });
      }

      this.comboValue = 0;

      this.initializeDropzone(id, 0);
    },

    addBlockFromOuter: function(value, label, files) {
      var _this = this;

      var id = this.$root.guid();

      if (files == undefined)
        files = [];

      this.blocks.push({
        id: id,
        value: value,
        label: label,
        files: files,
        selected_files_to_upload_amount: files.length,
        dropzone: '',
        error: '',
        file_upload_in_progress: false
      });

      // Ha blokkot csak egyszer lehet hozzáadni
      if (this.block_once) {
        this.options.map(function(opt) {
          if (parseInt(opt.value) == parseInt(value)) {
            opt.show = 0;
          }
        });
      }

      this.initializeDropzone(id, 0);

      this.$emit('change', this.getValue());
    },

    getBlockByID: function(id) {
      var ret = false;
      this.blocks.map(function(block) {
        if (block.id == id)
          ret = block;
      });
      return ret;
    },

    getBlocksToSave: function() {
      var tmp = [];
      this.blocks.map(function(block) {
        tmp.push({
          id: block.id,
          value: block.value,
          label: block.label,
          files: block.files,
          selected_files_to_upload_amount: block.selected_files_to_upload_amount,
          dropzone: '',
          error: '',
          file_upload_in_progress: false
        });
      });
      return tmp;
    },

    setBlocks: function(blocks) {
      var _this = this;

      this.blocks = blocks;

      this.blocks.map(function(block) {
        _this.initializeDropzone(block.id, 0);

        if (_this.block_once) {
          _this.options.map(function(option) {
            if (parseInt(option.value) == parseInt(block.value)) {
              option.show = 0;
            }
          });
        }
      });

      this.$emit('change', this.getValue());
    },

    changeComboValue: function(value) {
      this.comboValue = value;
    },

    getComboLabelByValue: function(value) {
      var text = '';
      this.options.map(function(option) {
        if (option.value == value)
          text = option.text;
      });
      return text;
    },

    getFilePath: function(file) {
      return 'api/uploads/' + file;
    },

    getValue: function() {
      var r = [];

      this.blocks.map(function(block, i) {
        r.push({
          id: block.value,
          label: block.label,
          files: block.files
        });
      });

      return r;
    },

    comboChange: function() {
      if (this.comboValue != 0)
        this.addBlock();

      this.$emit('change', this.getValue());
    },

    deleteFileFromServer: function(file) {
      this.$root.ajax('form/deletefile/' + file, {
        success: function(response) {

        }
      });
    },

    deleteUploadedFile: function(block_id, file) {
      var _this = this;

      swal({
        title: "Biztos törli a feltöltött dokumentumot?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Nem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.deleteFileFromServer(file);

          var block;
          _this.blocks.map(function(b) {
            if (b.id == block_id)
              block = b;
          });

          var tmp = [];
          block.files.map(function(file_) {
            if (file != file_)
              tmp.push(file_);
          });
          block.files = tmp;
          block.selected_files_to_upload_amount--;

          _this.$emit('change', _this.getValue());

          _this.initializeDropzone(block.id, block.files.length);
        }
      });
    },

    initializeDropzone: function(id, uploaded_files_amount) {
      var _this = this;

      this.$nextTick(function() {
        var block;
        _this.blocks.map(function(b) {
          if (b.id == id)
            block = b;
        });

        if (block.file_upload_in_progress)
          return;

        if (block != undefined && block.dropzone != '')
          block.dropzone.destroy();

        setTimeout(function() {
          block.dropzone = new Dropzone("#" + id, {
            url: api_url + 'form/uploadfile/',
            method: 'post',
            paramName: 'name_' + id,
            autoProcessQueue: true,
            parallelUploads: 1,
            maxFiles: _this.maxfiles - uploaded_files_amount,
            acceptedFiles: _this.accepted_files,
            previewsContainer: false,
            autoDiscover: false,
            init: function () {
              this.on("success", function (file, response) {
                if (!$.isPlainObject(response))
                  response = JSON.parse(response);

                if (response.error == false) {
                  response.uploaded_files.map(function(file) {
                    block.files.push(file);
                  });

                  block.error = '';

                  _this.$emit('change', _this.getValue());

                } else {
                  this.removeFile(file);
                  swal('Hiba', response.error, 'error');
                }
              });
              this.on("sending", function (response) {
                block.file_upload_in_progress = true;
              }),
              this.on("queuecomplete", function (response) {
                this.removeAllFiles(true);
                block.file_upload_in_progress = false;
                _this.initializeDropzone(id, uploaded_files_amount);
              });
              this.on("addedfile", function (file) {
                if (file.size > _this.max_uploaded_filesize) {
                  this.removeFile(file);
                  swal('Hiba', 'Túl nagy a feltöltendő fájl mérete ('+file.name+'). Maximum ' + _this.max_uploaded_filesize_mb + 'Mbyte tölthető fel.', 'error');
                  return;
                }

                if ($.inArray(file.type, _this.accepted_files.split(',')) == -1) {
                  this.removeFile(file);
                  swal('Hiba', 'A feltöltendő fájltípus nem engedélyezett.', 'error');
                  return;
                } else if (block.selected_files_to_upload_amount + 1 > _this.maxfiles) {
                  this.removeFile(file);
                  return;
                }
                block.selected_files_to_upload_amount++;
              });
            }
          });
        }, 100);
      });
    }
  }
});

Vue.component('UploadHandlerHianypotlas', {
  props: {
    errors: {
      type: Array,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    max_uploaded_files: {
      type: [String, Number],
      required: true
    },
    hianypotlas_fields: {
      type: Array,
      required: true,
      default: []
    },
  },
  mixins: [myMixin],
  data: function() {
    return {
      maxfiles: this.max_uploaded_files == undefined ? 3 : this.max_uploaded_files,
      label: '',
      accepted_files: '',
      blocks: [],
      max_uploaded_filesize_mb: 0,
      max_uploaded_filesize: 0
    };
  },
  template: `
    <div v-if="blocks.length > 0" class="form-group" style="padding-bottom:0px" v-bind:class="{error: error.length}">
      <div class="form-upload-block" v-for="(block, i) in blocks">
        <div class="form-upload-block-header" style="margin:0px">
          <h2>{{ label }} - {{ block.label }}</h2>
        </div>
        <div class="info-box warning" style="margin:2px 0px">
        {{ block.msg }}
        </div>
        <div v-if="block.files.length > 0">
          <div v-for="(file, j) in block.files" class="profile-publication-item">
            <div class="text">
              <i class="fa fa-file-o"></i><a target="_blank" :href="getFilePath(file)">{{ file }}</a>
            </div>
            <div class="links">
              <a v-on:click="deleteUploadedFile(block.form_fill_values_id, block.array_index, file)" href="javascript:void(0)" class="link v2"><i class="fa fa-trash-o"></i></a>
            </div>
          </div>
        </div>
        <div :id="block.id" v-show="block.files.length < maxfiles" style="width: 100%; margin-bottom: 10px;" class="upload-zone">
          <i class="fa fa-cloud-upload"></i>
            Új dokumentum feltöltés
          <span>Húzza ide a feltöltendő fájlokat. {{ maxfiles - block.files.length }} fájl tölthető fel.</span>
          <input :name="'name_'+block.id" type="file" />
        </div>
        <div v-if="block.error != ''" class="form-error">{{ block.error }}</div>
      </div>
    </div>
  `,
  watch: {
    errors: function() {
      var _this = this;

      this.blocks.map(function(block) {
        block.error = '';
      });

      if (this.errors == undefined || this.errors.length == 0)
        return '';

      this.errors.map(function(err) {
        _this.blocks.map(function(block) {
          if (block.form_fill_values_id == err.form_fill_values_id && block.array_index == err.array_index)
            block.error = err.msg;
        })
      });
    }
  },
  mounted: function() {
    var _this = this;

    this.getMaxUploadedFileSize();

    this.hianypotlas_fields.map(function(hf) {
      if (hf.form_field_key == _this.name) {
        _this.label = hf.form_field_name;
        _this.accepted_files = hf.accepted_files;

        for (var i = 0; i < hf.hianypotlas.length; i++) {
          _this.blocks.push({
            id: hf.form_field_key+ '_' + hf.hianypotlas[i].array_index + '_' + hf.id,
            form_fill_values_id: hf.id,
            label: hf.form_field_option_name,
            array_index: hf.hianypotlas[i].array_index, // Melyik tömbbe kell majd a fájlokat feltölteni (change-nél van használva)
            msg: hf.hianypotlas[i].msg,
            files: [],
            dropzone: '',
            error: ''
          });

          _this.initializeDropzone(hf.form_field_key+ '_' + hf.hianypotlas[i].array_index + '_' + hf.id, hf.id, hf.hianypotlas[i].array_index, 0);
        }
      }
    });
  },
  methods: {
    getMaxUploadedFileSize: function() {
      var _this = this;

      this.$root.ajax('max_feltoltheto_fajlmeret/', {
        success: function(response) {
          _this.max_uploaded_filesize_mb = response.max_uploaded_filesize_mb;
          _this.max_uploaded_filesize = response.max_uploaded_filesize;
        }
      });
    },

    getFilePath: function(file) {
      return 'api/uploads/' + file;
    },

    getValue: function() {
      var r = [];

      this.blocks.map(function(block, i) {
        r.push({
          id: block.id,
          form_fill_values_id: block.form_fill_values_id,
          array_index: block.array_index,
          files: block.files
        });
      });

      return r;
    },

    deleteUploadedFile: function(form_fill_values_id, array_index, file) {
      var _this = this;

      swal({
        title: "Biztos törli a feltöltött dokumentumot?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Nem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          var tmp = [];
          var block;

          _this.blocks.map(function(b) {
            if (b.form_fill_values_id == form_fill_values_id && b.array_index == array_index) {
              block = b;
            }
          });

          block.files.map(function(file_) {
            if (file != file_)
              tmp.push(file_);
          });
          block.files = tmp;

          _this.$emit('change', _this.name, _this.getValue());

          _this.initializeDropzone(block.id, block.form_fill_values_id, block.array_index, block.files.length);
        }
      });
    },

    initializeDropzone: function(id, form_fill_values_id, array_index, uploaded_files_amount) {
      var _this = this;

      this.$nextTick(function() {
        var block;

        _this.blocks.map(function(b) {
          if (b.form_fill_values_id == form_fill_values_id && b.array_index == array_index)
            block = b;
        });

        if (block.dropzone != '') {
          block.dropzone.destroy();
        }

        setTimeout(function() {
          block.dropzone = new Dropzone("#" + id, {
            url: api_url + 'form/uploadfile/',
            method: 'post',
            paramName: 'name_' + id,
            autoProcessQueue: true,
            parallelUploads: 1,
            maxFiles: _this.maxfiles - uploaded_files_amount,
            acceptedFiles: _this.accepted_files,
            previewsContainer: false,
            autoDiscover: false,
            init: function () {
              this.on("success", function (file, response) {
                if (!$.isPlainObject(response))
                  response = JSON.parse(response);

                if (response.error == false) {
                  response.uploaded_files.map(function(file) {
                    block.files.push(file);
                  });

                  _this.$emit('change', _this.name, _this.getValue());

                } else {
                  this.removeFile(file);
                  swal('Hiba', response.error, 'error');
                }
              });
              this.on("queuecomplete", function (response) {
                this.removeAllFiles(true);
                _this.initializeDropzone(id, form_fill_values_id, array_index, uploaded_files_amount);
              });
              this.on("addedfile", function (file) {
                if (file.size > _this.max_uploaded_filesize) {
                  this.removeFile(file);
                  swal('Hiba', 'Túl nagy a feltöltendő fájl mérete. Maximum ' + _this.max_uploaded_filesize_mb + 'Mbyte tölthető fel.', 'error');
                  return;
                }

                if ($.inArray(file.type, _this.accepted_files.split(',')) == -1) {
                  this.removeFile(file);
                  swal('Hiba', 'A feltöltendő fájltípus nem engedélyezett.', 'error');
                } else if (uploaded_files_amount + 1 > _this.maxfiles) {
                  this.removeFile(file);
                  swal('Hiba', 'Maximálisan ' + _this.maxfiles + ' fájl tölthető fel.', 'error');
                }
              });
            }
          });
        }, 100);
      });
    }
  }
});

Vue.component('DocumentUploader', {
  props: {
    title: {
      type: String,
      required: false,
      default: 'Szükséges igazolások'
    },
  },
  data: function() {
    return {
      max_uploaded_filesize_mb: 0,
      max_uploaded_filesize: 0,
      blocks: []
    };
  },
  template: `
    <div v-if="blocks.length > 0" class="file-upload-panel">
      <div class="title">
      {{ title }}
      </div>
      <div class="content">
        <div v-for="(block, i) in blocks" in class="file">
          <i :class="iconClass(block)"></i>
          <form v-show="block.filename == ''" action="api/form/tamogatas_fajlfeltoltes/" method="post" :id="'block_form_'+block.id" enctype="multipart/form-data">
            <input v-on:change="fileUpload(block.id)" type="file" :id="'newfile_'+block.id" :name="'newfile_'+block.id" :ref="'newfile_'+block.id" value="">
          </form>

          <div class="name">{{ block.name }}</div>
          <div class="description">{{ block.description }}</div>
          <div v-show="block.upload_in_progress" class="upload-progress-bar">
            <div :style="{width: block.upload_info_percent+'%'}" class="bar"></div>
          </div>

          <div class="buttons">
            <a target="_blank" v-if="block.filename != ''" :href="'api/uploads/'+block.filename" title="" class="small-button download">
              <i class="fa fa-save"></i>
            </a>
            <a v-if="block.filename != ''" v-on:click="deleteFile(block.filename, block.id)" href="javascript:void(0)" title="" class="small-button">
              <i class="fa fa-trash-o"></i>
            </a>
            <a v-if="block.filename == '' && !block.upload_in_progress" v-on:click="selectFileToUpload(block.id)" href="javascript:void(0)" title="" class="small-button upload">
              <i class="fa fa-upload"></i>
            </a>
          </div>
        </div>
        <div class="upload-info">
          Feltöltött igazolások: {{ uploaded_file_amount }} / {{ blocks.length }}
        </div>
      </div>
    </div>
  `,
  computed: {
    uploaded_file_amount: function() {
      var c = 0;

      this.blocks.map(function(block) {
        if (block.filename != '')
          c++;
      });

      return c;
    }
  },
  watch: {
    blocks: function() {
      this.setAjaxForm();
    }
  },
  mounted: function() {
    var _this = this;
    this.setAjaxForm();
    this.getMaxUploadedFileSize();
  },
  methods: {
    getMaxUploadedFileSize: function() {
      var _this = this;

      this.$root.ajax('max_feltoltheto_fajlmeret/', {
        success: function(response) {
          _this.max_uploaded_filesize_mb = response.max_uploaded_filesize_mb;
          _this.max_uploaded_filesize = response.max_uploaded_filesize;
        }
      });
    },

    isAllFilesUpload: function() {
      var all = true;

      this.blocks.map(function(block) {
        if (block.filename == '')
          all = false;
      });

      return all;
    },

    newBlock: function(block_id, block_name, block_description) {
      var _this = this;
      var can_be_added = true;

      this.blocks.map(function(block) {
        if (block.id == block_id)
          can_be_added = false;
      });

      if (can_be_added)
        this.blocks.push({
          id: block_id,
          name: block_name,
          description: block_description,
          filename: '',
          ajaxform: false,
          upload_info_percent: 0,
          upload_in_progress: false,
          xhr: ''
        });
    },

    modifyBlock: function(block_id, block_name, block_description) {
      this.blocks.map(function(block) {
        if (block.id == block_id) {
          block.name = block_name;
          block.description = block_description;
        }
      });
    },

    deleteBlock: function(block_id) {
      var _this = this;
      var filename;

      var tmp = [];
      _this.blocks.map(function(block) {
        if (block.id != block_id) {
          tmp.push(block);
        } else {
          $('#block_form_' + block.id).ajaxFormUnbind();

          if (block.xhr != undefined && block.xhr != '')
            block.xhr.abort();

          block.ajaxform = false;
          filename = block.filename;
        }
      });
      _this.blocks = tmp;

      if (filename != undefined && filename != '')
        _this.deleteFile(filename, false);
    },

    setAjaxForm: function() {
      var _this = this;

      Vue.nextTick(function() {

        _this.blocks.map(function(block) {
          //if (block.ajaxform == false) {
            block.ajaxform = true;

            setTimeout(function() {
              $('#block_form_' + block.id).ajaxForm({
                dataType:'json',
                data: {
                  block_id: block.id
                },
                beforeSend: function(xhr) {
                  block.xhr = xhr;
                  block.upload_in_progress = true;
                },
                uploadProgress: function(event, position, total, percentComplete) {
                  block.upload_info_percent = percentComplete;
                },
                success:function(response, statusText, xhr, $form) {
                  block.upload_in_progress = false;
                  block.upload_info_percent = 0;

                  if (response.status == 'OK') {
                    block.filename = response.filename;

                    $('#newfile_'+block.id).val('');

                    _this.$emit('onFileUploaded', _this.getData());

                  } else {
                    if (response.msg != undefined)
                      swal({
                        title: 'Hiba!',
                        text: response.msg,
                        type: 'error'
                      });
                  }
                }
              });
            }, 100);
          //}
        });
      });
    },

    getData: function() {
      var tmp = [];
      this.blocks.map(function(block) {
        tmp.push({
          id: block.id,
          name: block.name,
          filename: block.filename,
          description: block.description
        });
      });
      return tmp;
    },

    setFullData: function(blocks) {
      this.blocks = blocks;
    },

    fileUpload: function(block_id) {
      var filesize = this.$refs['newfile_'+block_id][0].files[0].size;

      if (filesize >= this.max_uploaded_filesize) {
        swal({
          title: 'Hiba!',
          text: 'Maximum ' + this.max_uploaded_filesize_mb + ' Mbyte méretű fájl tölthető fel.',
          type: 'error'
        });
        return;
      }

      $('#block_form_' + block_id).submit();
    },

    selectFileToUpload: function(block_id) {
      this.$refs['newfile_'+block_id][0].click();
    },

    deleteFile: function(block_filename, block_id) {
      if (block_id != false) {
        this.blocks.map(function(block) {
          if (block.id == block_id) {
            block.filename = '';
          }
        });
      }

      if (block_filename == '')
        return;

      this.$root.ajax('form/tamogatas_fajltorles/', {
        data: {
          filename: block_filename
        },
        method: 'post',
        success: function(response) {
          if (response.error) {
            swal({
              title: 'Hiba!',
              text: response.error,
              type: 'error'
            });
          }
        }
      });
    },

    iconClass: function(block) {
      if (block.filename == '')
        return 'fa fa-close';
      else
        return 'fa fa-check';
    }
  }
});

Vue.component('PointPanel', {
  props: {
    title: {
      type: String,
      required: false,
      default: 'Elért pontszámok'
    },
  },
  data: function() {
    return {
      points: []
    };
  },
  template: `
    <div v-if="points.length > 0" class="point-panel">
      <div class="title">
        {{ title }}
        <div class="sumpoint">
          {{ sumPoint }}
        </div>
      </div>
      <div class="content">
        <div v-for="(point, i) in points" class="point-block">
          <div class="point">
            {{ point.value }}
          </div>
          <div class="meta">
            <div class="name">
              {{ point.title }}
            </div>
            <div v-if="point.description != ''" class="description">
              {{ point.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  computed: {
    sumPoint: function() {
      var total = 0;

      this.points.map(function(point) {
        total += parseFloat(point.value);
      });

      return total;
    }
  },

  watch: {

  },

  mounted: function() {
    var _this = this;
  },

  methods: {
    setFullData: function(points) {
      this.points = points;
    },

    getData: function() {
      return this.points;
    },

    addPoint: function(id, title, description, value) {
      var can_be_added = true;

      this.points.map(function(point) {
        if (point.id == id)
          can_be_added = false;
      });

      if (can_be_added)
        this.points.push({
          id: id,
          title: title,
          description: description,
          value: value
        })
    },

    removePoint: function(id) {
      var tmp = [];
      this.points.map(function(point) {
        if (point.id != id)
          tmp.push(point);
      });
      this.points = tmp;
    },

    changePointValue: function(id, value) {
      this.points.filter(function(point) {
        if (point.id == id)
          point.value = value;
      });
    }
  }
});

Vue.component('Tooltip', {
  props: {
    description: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      id: '',
      active: false
    };
  },
  template: `
    <div v-if="description != ''" class="tooltip" :id="id">
      <i v-on:mouseover="iconMouseOver" v-on:mouseout="iconMouseOut" class="fa fa-question-circle"></i>
      <div :class="{show: active}" class="description" v-html="description"></div>
    </div>
  `,
  mounted: function() {
    this.id = 'tooltip_' + this.$root.guid();
  },

  methods: {
    iconMouseOver: function() {
      this.active = true;

      var obj = $('#' + this.id);

      // Ha kilógna jobbra a képernyőből, akkor balra helyezi
      if ($(obj).offset().left + $(obj).find('.description').outerWidth() > $(window).innerWidth()) {
        $(obj).addClass('desc-left');
      } else {
        $(obj).removeClass('desc-left');
      }
    },

    iconMouseOut: function() {
      this.active = false;
    }
  }
});

Vue.component('FormContactData', {
  props: {
    data: {
      type: [Object,String],
      required: true
    }
  },
  template: `
    <div class="popup-overlay">
      <div class="popup">
        <button type="button" class="close-btn" v-on:click="close">
          <i class="fa fa-close"></i>
        </button>
        <h1>Kapcsolattartó adatai</h1>
        <div v-if="data != ''" class="description">
          <ul class="ordered-list with-icon">
            <li v-if="data.nev != ''">
              <i class="fa fa-user"></i><span class="highlight">Név:</span> {{ data.nev }}
            </li>
            <li v-if="data.szervezeti_egyseg != ''">
              <i class="fa fa-university"></i><span class="highlight">Szervezeti egység:</span> {{ data.szervezeti_egyseg }}
            </li>
            <li v-if="data.iroda != ''">
              <i class="fa fa-briefcase"></i><span class="highlight">Iroda:</span> {{ data.iroda }}
            </li>
            <li v-if="data.telefon != ''">
              <i class="fa fa-phone"></i><span class="highlight">Telefon:</span> {{ data.telefon }}
            </li>
            <li v-if="data.email != ''">
              <i class="fa fa-envelope"></i><span class="highlight">Email:</span> <a :title="data.email" :href="'mailto:'+data.email">{{ data.email }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  `,
  methods: {
    close: function() {
      this.$emit('onClose');
    }
  }
});
</script>



// WEBPACK FOOTER //
// components.vue?649c45ca